/** PROTOTYPED */
const getLocale = () => ({
  general: {
    voltar: "Voltar",
    abrirMenu: "Abrir menu",
    procurar: "Procurar",
    adicionar: "Adicionar",
    editar: "Editar",
    informacoes: "Informações",
    buscar: "Buscar",
    salvar: "Salvar",
    duplicar: "Duplicar",
    deletar: "Deletar",
    abrir: "Abrir",
    salvarEdicao: "Salvar edição",
    semDados: "Não há dados cadastrados",
    semConexao: "Atenção: não há conexão com a internet. A única funcionalidade disponível é a de cadastro de trechos de voo, disponível no menu. Todas as outras funcionalidades apresentarão erro.",
    alertas: "Alertas",
    desde: "desde",
    pesquisar: "Pesquisar",
    sim: "Sim",
    nao: "Não",
    ambos: "Ambos",
    consulta: "Consulta",
    exportar: "Exportar",
    exportarPDF: "Exportar PDF",
    exportarXLS: "Exportar XLS",
    exportarXLSX: "Exportar XLSX",
    exportarTextoCSV: "Exportar CSV",
    diaMesAno: "dd/mm/aaaa",
    mesAno: "mm/aaaa",
    horaMinuto: "hh:mm",
    diaMesAnoHoraMinuto: "dd/mm/aaaa hh:mm",
    recarregar: "Recarregar",
    importar: "Importar",
    justificar: "Justificar",
    atualizar: "Atualizar",
    filtrar: "Filtrar",
    cancelar: "Cancelar",
    aberta: "Aberta",
    expiracao: "Expiração",
    realizada: "Realizada",
    euro: "Euro",
    dolar: "Dólar",
    real: "Real",
    mudarLinguagem: "Change to English",
    ingles: "Inglês",
    portugues: "Português",
    offlineRefresh: "Você está offline. O sistema não será recarregado. Tem certeza que deseja continuar?",
  },

  Calendario: {
    Calendario: {
      tabela: {
        Domingo: "Domingo",
        SegundaFeira: "Segunda-feira",
        TercaFeira: "Terça-feira",
        QuartaFeira: "Quarta-feira",
        QuintaFeira: "Quinta-feira",
        SextaFeira: "Sexta-feira",
        Sabado: "Sábado",
      }
    }
  },

  Controles: {
    ExtratoMensalDePagamentosPorDataDeReferencia: {
      opcoesTipos: {
        Missao: "Missão",
        Treinamento: "Treinamento",
      },

      opcoesMissao: {
        Diarias: "Diárias",
        RepresentanteOperacional: "Representante Operacional",
        Transporte: "Transporte",
        Deslocamento: "Deslocamento",
        Extra: "Extra",
      },

      opcoesTreinamento: {
        Diarias: "Diárias",
        Cheques: "Cheques",
        Extra: "Extra",
      },

      titulo: "Extrato Mensal de Pagamentos - Por Data de Referência",

      botaoTutorial: "Tutorial",

      paragrafoOControleExibeTodosOspagamentos: "O controle exibe todos os pagamentos independente de estarem na listagem em aberto ou em alguma ordem de pagamentos",
      paragrafoADataDeReferenciaParaAPesquisa: "A data de referência para a pesquisa é a data do período da escala ou treinamento relacionado ao pagamento",

      formulario: {
        Periodo: "Período",
        ExibirPagamentosAbertos: "Exibir pagamentos abertos",
      },

      tabelaSaldos: {
        semSaldoAnterior: "Nenhum saldo anterior encontrado",
        SaldoAnterior: "Saldo Anterior",
      },

      tabelaPagamentos: {
        semPagamentos: "Nenhum pagamento encontrado",
        BaseOperacional: "Base Operacional",
        Periodo: "Período",
        TipoDeOrdem: "Tipo de Ordem",
        Treinamento: "Treinamento",
        CodigoDeControle: "Código de Controle",
        Revisao: "Revisão",
        TipoDePagamento: "Tipo de Pagamento",
        Status: "Status",
        Quantidade: "Quantidade",
        ValorUnitario: "Valor/Unitário",
        ValorOriginal: "Valor Original",
        Desconto: "Desconto",
        ValorRecebido: "Valor Recebido",
        Saldo: "Saldo",
        DataDoPagamento: "Data do Pagamento",
        Acoes: "Ações",
      },

      tabelaValores: {
        semValores: "Nenhum valor consolidado encontrado",
        ValorOriginal: "Valor Original",
        Desconto: "Desconto",
        ValorRecebido: "Valor Recebido",
        Saldo: "Saldo",
      },

      tituloDiasDoPagamento: "Dias do pagamento",

      tabelaDiasDoPagamento: {
        Data: "Data",
        Diarias: "Diárias",

        nenhumDiaEncontrado: "Nenhum dia encontrado. Certas informações só passaram a ser gravadas à partir de 05/2022",
      },

      tituloDescontosRelacionados: "Descontos Relacionados",

      tabelaDescontosRelacionados: {
        IdDoDebito: "Id do débito",
        ReferenciaDoDebito: "Referência do débito",
        ValorOriginalDoDebito: "Valor original do débito",
        ValorAmortizadoNoPagamento: "Valor amortizado no pagamento",
      },

      tituloPagamentosRelacionados: "Pagamentos Relacionados",

      tabelaPagamentosRelacionados: {
        IdDoDebito: "Id do débito",
        ReferenciaDoPagamento: "Referência do pagamento",
        ValorOriginalDoDebito: "Valor original do débito",
        ValorAmortizadoNoPagamento: "Valor amortizado no pagamento",
      },
    },

    ExtratoPagamentosPorPeriodoPorDataDePagamento: {
      titulo: "Extrato Pagamentos por Período - Por Data de Pagamento",

      paragrafoOControleExibeTodosOspagamentos: "O controle exibe todos os pagamentos independente de estarem na listagem em aberto ou em alguma ordem de pagamentos",
      paragrafoAsDatasDeReferenciaParaAPesquisa: "As datas de referência para a pesquisa são as datas do pagamento",

      formulario: {
        Inicio: "Início",
        Termino: "Término",
      },

      tabelaPagamentos: {
        semPagamentos: "Nenhum pagamento encontrado",
        BaseOperacional: "Base Operacional",
        Frota: "Frota",
        Periodo: "Período",
        TipoDeOrdem: "Tipo de Ordem",
        Treinamento: "Treinamento",
        CodigoDeControle: "Código de Controle",
        Revisao: "Revisão",
        TipoDePagamento: "Tipo de Pagamento",
        Status: "Status",
        Quantidade: "Quantidade",
        ValorUnitario: "Valor/Unitário",
        ValorOriginal: "Valor Original",
        Desconto: "Desconto",
        ValorRecebido: "Valor Recebido",
        Saldo: "Saldo",
        DataDoPagamento: "Data do Pagamento",
        Acoes: "Ações",
      },

      tituloDiasDoPagamento: "Dias do pagamento",

      tabelaDiasDoPagamento: {
        Data: "Data",
        Diarias: "Diárias",

        nenhumDiaEncontrado: "Nenhum dia encontrado. Certas informações só passaram a ser gravadas à partir de 05/2022",
      },

      tituloDescontosRelacionados: "Descontos Relacionados",

      tabelaDescontosRelacionados: {
        IdDoDebito: "Id do débito",
        ReferenciaDoDebito: "Referência do débito",
        ValorOriginalDoDebito: "Valor original do débito",
        ValorAmortizadoNoPagamento: "Valor amortizado no pagamento",
      },

      tituloPagamentosRelacionados: "Pagamentos Relacionados",

      tabelaPagamentosRelacionados: {
        IdDoDebito: "Id do débito",
        ReferenciaDoPagamento: "Referência do pagamento",
        ValorOriginalDoDebito: "Valor original do débito",
        ValorAmortizadoNoPagamento: "Valor amortizado no pagamento",
      },
    }

  },

  EscalasDeTesteDeSonolencia: {

    ListaDeEscalasDeTesteDeSonolencia:{
      titulo: "Lista de escalas de teste de sonolência",
      botaoAdicionarEscala: "Adicionar escala",

      tabela:{
        semEscalas: "Não há escalas de testes cadastradas",
        ID: "ID",
        Nome: "Nome",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Acoes: "Ações",
      }
    },

    AdicionarEscalaDeSonolencia: {
      aguardeEnquantoAEscalaEGerada: "Aguarde enquanto a escala é gerada. Este processo pode levar alguns minutos.",
      titulo: "Cadastrar escala de testes de sonolência",

      formulario: {
        Nome: "Nome",
        HorariosDeEnvio: "Horários de envio",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Tripulantes: "Tripulantes",
        Mecanicos: "Mecânicos",
        Coordenadores: "Coordenadores",
        botaoAdicionarEscalaDeTeste: "Adicionar escala de teste",

        placeholder: {
          NomeDaEscalaDeSonolencia: "Nome da escala de sonolência",
          HorariosDeEnvio: "hh:mm, separados por virgula.",
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
        }
      }

    },

    EditarEscalaDeSonolencia: {
      trocarStatusDaEscala: "Tem certeza que gostaria de trocar o status da escala?",
      trocarStatusDaEscalaParaAprovado: "Tem certeza que gostaria de trocar o status da escala para aprovado?",
      trocarStatusDaEscalaParaFinalizado: "Tem certeza que gostaria de trocar o status da escala para finalizado?",

      titulo: "Edição de escala de sonolência",

      botaoDeFichas: {
        TrocarParaAprovado: "Trocar para aprovado",
        TrocarParaFinalizado: "Trocar para finalizado",
      },

      tabDadosDaEscala: {
        tituloTab: "Dados da escala",
        formulario: {
          Nome: "Nome",
          DataInicial: "Data inicial",
          DataFinal: "Data final",

          placeholder: {
            NomeDaEscalaDeSonolencia: "Nome da escala de sonolência",
          }
        }
      },

      tabTestesDeEscala: {
        tituloTab: "Testes de escala",

        deletarColaboradorDaEscalaDeTeste: "Tem certeza que gostaria de deletar esse colaborador da escala de testes?",

        tituloTestesDeEscalaDeSonolencia: "Testes de escala de sonolência",
        
        tabela: {
          semColaboradores: "Não há colaboradores cadastrados",
          ID: "ID",
          Colaborador: "Colaborador",
          ProgramacaoDeEnvio: "Programação de Envio",
          Acoes: "Ações",
        },

        tituloEditarTeste: "Editar teste",

        formulario: {
          Data: "Data",
          HorariosDeEnvio: "Horário de envio",
          Colaborador: "Colaborador",

          placeholder: {
            HorariosDeEnvio: "Horário de envio",
            SelecionarAplicabilidade: "Selecionar aplicabilidade",
          }
        }
      },

      tabRelatorioFinal: {
        tituloTab: "Relatório final",
        
        formulario: {
          PeriodoDeJornada: "Período de Jornada",
          DiasDeJornada: "Dias de jornada",
          Bases: "Bases",
          Designacoes: "Designações",
          Funcoes: "Funções",
          Cargos: "Cargos",
          Frotas: "Frotas",
          Grupos: "Grupos",

          botaoProcurarRelatorios: "Procurar relatórios",

          placeholder:{
            SelecionarPeriodoDeJornada: "Selecionar períodos de jornada",
            DiasDeJornada: "Dias, separados por virgula. Ex.: 01,02,10,11,etc.",
            SelecionarBases: "Selecionar bases",
            SelecionarDesignacoes: "Selecionar designações",
            SelecionarFuncoes: "Selecionar funções",
            SelecionarCargos: "Selecionar cargos",
            SelecionarFrotas: "Selecionar frotas",
            SelecionarGrupos: "Selecionar grupos",
          }
          
        },

        tituloPontosPorHorarioDeResposta: "Pontos por horário de resposta",

        paragrafoPercentualDeAdesaoParcial: "Percentual de adesão parcial (até a data)",
        paragrafoPercentualDeAdesaoGlobal: "Percentual de adesão global",
        paragrafoTempoMedioDeResposta: "Tempo médio de resposta",
        paragrafoTotalRespostas: "Total respostas",

        tituloCadaHorarioDeResposta: "Cada horário de resposta",

        tabelaHorariosDeResposta: {
          PeriodoHoras: "Período horas",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },

        tituloPontosPorPeriodoDeJornada: "Pontos por período de jornada",

        tabelaPontosPorPeriodoDeJornada: {
          PeriodoHoras: "Período horas",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },

        tituloPontosPorDiasDeJornada: "Pontos por dias de jornada",

        tabelaPontosPorDiasDeJornada: {
          PeriodoDias: "Período dias",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },

        tituloBases: "Bases",

        tabelaBases: {
          Base: "Base",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },

        tituloFuncoes: "Funções",
      
        tabelaFuncoes: {
          Funcao: "Função",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },

        tituloGrupos: "Grupos",

        tabelaGrupos: {
          Grupo: "Grupo",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },

        tituloDesignacoes: "Designações",

        tabelaDesignacoes: {
          Designacao: "Designação",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },
        
        tituloFrotas: "Frotas",

        tabelaFrotas: {
          Frota: "Frota",
          Total: "Total",
          Pontos: "Pontos",
          Media: "Média",
        },
      },

    },
  },

  TripulanteDeslocamentos: {
    AdicionarDeslocamento: {
      titulo: 'Adicionar deslocamento',
      tituloAnteriores: 'Deslocamentos anteriores',

      formulario: {
        houveDeslocamento: 'Houve deslocamento para sua apresentação no aeroporto',
        tempoDeslocamento: 'Quanto tempo de deslocamento (inclui desde a saída de sua residência até a chegada no hotel ou aeroporto, o que tiver ocorrido primeiro)',
        botaoSalvar: 'Salvar'
      },

      tabela: {
        dataApresentacao: 'Data apresentação',
        houveDeslocamento: 'Houve deslocamento?',
        tempoDeslocamento: 'Tempo de deslocamento',
        Status: 'Status',
      },
    }
  },

  TripulanteDiscrepancias: {
    AdicionarDiscrepancia: {
      titulo: 'Adicionar discrepância',
      tituloAnteriores: 'Discrepâncias anteriores',

      formulario: {
        Data: 'Data',
        Discrepancia: 'Discrepância',
        grauEstresse: 'Grau de severidade/estresse',
        botaoAdicionar: 'Adicionar'
      },

      tabela: {
        Data: 'Data',
        Discrepancia: 'Discrepância',
        grauEstresse: 'Grau de severidade/estresse',
      },
    }
  },

  Fadigas: {

    ListaDeFadigas: {
      deletar: "Tem certeza que gostaria de deletar esse parâmetro de fadiga?",

      titulo: "Lista de parâmetros de fadigas",
      
      botaoAdicionarFadiga: "Adicionar Fadiga",
      
      tabela: {
        semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
        ID: "ID",
        Aplicabilidade: "Aplicabilidade",
        Nome: "Nome",
        Tipo: "Tipo",
        Operador: "Operador",
        PontosPorHora: "PontosPorHora",
        PontosPorQuantidade: "Pontos por quantidade",
        LimiteDePontos: "Limite de pontos",
        ObrigatorioPreenchimento: "Obrigatório preenchimento",
        Acoes: "Ações",
      }
    },

    AdicionarFadiga: {
      titulo: "Cadastrar parâmetro de fadiga",
      formulario: {
        Nome: "Nome",
        Tipo: "Tipo",
        Operador: "Operador",
        PontosPorHora: "Pontos por hora",
        PontosPorQuantidade: "Pontos por quantidade",
        LimiteDePontos: "Limite de pontos",
        PontuacaoExtraPorHoraNoturna: "Pontuação Extra por Hora Noturna",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        PontosAReduzirParaTreinamento: "Pontos a reduzir para treinamento",
        ParametroObrigatorio: "Parâmetro Obrigatório"  ,
        ParametroAutomatico: "Parâmetro Automático",
        TipoDeAutomacao: "Tipo de automação",

        tituloAlertas: "Alertas",

        LimiteMaximoDePontos: "Limite máximo de pontos",
        LimiteMinimoDePontos: "Limite mínimo de pontos",
        LimiteDePontosDeHoraExtraPorSemana: "Limite de pontos de hora extra por semana",
        LimiteDePontosDeHoraExtraPorMes: "Limite de pontos de hora extra por mês",
        LimiteDeDiasComHoraExtraPorSemana: "Limite de dias com hora extra por semana",
        LimiteDeDiasComHoraExtraPorMes: "Limite de dias com hora extra por mês",

        botaoAdicionarParametroDeFadiga: "Adicionar parâmetro de fadiga",

        placeholder: {
          NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
          SelecionarTipo: "Selecionar tipo",
          SelecionarOperador: "Selecionar operador",
          QuantidadeDePontosPorHora: "Quantidade de pontos por hora",
          QuantidadeDePontosPorQuantidade: "Quantidade de pontos por quantidade",
          LimiteDePontosDoParametro: "Limite de pontos do parâmetro",
          PontuacaoExtraPorHoraNoturna: "Pontuação Extra por Hora Noturna",
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          PontosAReduzirParaTreinamento: "Pontos a reduzir para treinamento",
          ParametroObrigatorio: "Parâmetro Obrigatório",
          ParametroAutomatico: "Parâmetro Automático",
          SelecionarTipo: "Selecionar tipo",
          LimiteMaximoDePontos: "Limite máximo de pontos",
          LimiteMinimoDePontos: "Limite mínimo de pontos",
        }
      }
    },

    EditarFadiga: {

      deletar: "Tem certeza que gostaria de deletar essa opção?",

      titulo: "Editar parâmetro de fadiga",

      formulario: {
        Nome: "Nome",
        Tipo: "Tipo",
        Operador: "Operador",
        PontosPorHora: "Pontos por hora",
        PontosPorQuantidade: "Pontos por quantidade",
        LimiteDePontos: "Limite de pontos",
        PontuacaoExtraPorHoraNoturna: "Pontuação Extra por Hora Noturna",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        PontosAReduzirParaTreinamento: "Pontos a reduzir para treinamento",
        ParametroObrigatorio: "Parâmetro Obrigatório"  ,
        ParametroAutomatico: "Parâmetro Automático",
        TipoDeAutomacao: "Tipo de automação",

        tituloAlertas: "Alertas",

        LimiteMaximoDePontos: "Limite máximo de pontos",
        LimiteMinimoDePontos: "Limite mínimo de pontos",
        LimiteDePontosDeHoraExtraPorSemana: "Limite de pontos de hora extra por semana",
        LimiteDePontosDeHoraExtraPorMes: "Limite de pontos de hora extra por mês",
        LimiteDeDiasComHoraExtraPorSemana: "Limite de dias com hora extra por semana",
        LimiteDeDiasComHoraExtraPorMes: "Limite de dias com hora extra por mês",

        placeholder: {
          NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
          SelecionarCliente: "Selecionar cliente",
          QuantidadeDePontosPorHora: "Quantidade de pontos por hora",
          QuantidadeDePontosPorQuantidade: "Quantidade de pontos por quantidade",
          LimiteDePontosDoParametro: "Limite de pontos do parâmetro",
          PontuacaoExtraPorHoraNoturna: "Pontuação Extra por Hora Noturna",
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          PontosAReduzirParaTreinamento: "Pontos a reduzir para treinamento",
          ParametroObrigatorio: "Parâmetro Obrigatório",
          ParametroAutomatico: "Parâmetro Automático",
          SelecionarTipo: "Selecionar tipo",
          LimiteMaximoDePontos: "Limite máximo de pontos",
          LimiteMinimoDePontos: "Limite mínimo de pontos",
        }
      },

      tituloAdicionarOpcoes: "Adicionar opções",
      formularioAdicionarOpcoes: {
        Nome: "Nome",
        Pontos: "Pontos",

        placeholder: {
          NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
          QuantidadeDePontos: "Quantidade de pontos",
        }
      },

      tituloOpcoes: "Opções",
      tabela: {
        Opcao: "Opção",
        Pontos: "Pontos",
        Acoes: "Ações"
      }

    }

  },

  RelatoriosAuxiliaresFadiga: {

    ProcurarRelatorioAuxiliar: {
      titulo: "Estatísticas (FAPA)",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
      },

      tituloResultadosDeAutoavaliacoes: "Resultados de Autoavaliações",

      tabela: {
        semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
        ID: "ID",
        Data: "Data",
        Colaborador: "Colaborador",
        Questao1: "Questão 1",
        Questao2: "Questão 2",
        Questao3: "Questão 3",
        Questao4: "Questão 4",
        PontuacaoFinal: "Pontuação final",
      }

    },

    AdicionarRelatorioAuxiliar: {
      titulo: "Ferramenta de Auxílio para Autoavaliação da Fadiga (FAPA)",

      formulario: {
        tituloQuestao1QuaoAlertaVoceEsta: "Questão 1: Quão alerta você acha que está? (Considere sua condição antes de assumir a jornada)",
        tituloQuestao2VoceTeveSonoAdequado: "Questão 2: Você teve um sono adequado?",
        QuantoTempoDormiuNas24HorasAnteriores: "No início da jornada, por quanto tempo dormiu nas 24 horas anteriores?",
        QuantoTempoDormiuNas48HorasAnteriores: "No início da jornada, por quanto tempo dormiu nas 48 horas anteriores?",
        AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado: "Ao fim da jornada prevista, por quantas horas você terá permanecido acordado, descontado qualquer tempo alocado para repouso em acomodação adequada ou repouso a bordo quando compondo tripulação aumentada?",
        tituloQuestao3QueHorasOcorreAPresenteJornada: "Questão 3: A que horas ocorre a presente jornada?",
        tituloQuestao4QualNivelDeRiscoOperacionalAssociado: "Questão 4: Qual o nível de risco operacional associado à jornada?",

        Rota: "Rota",

        Opcoes: {
          Baixo: "Baixo",
          Moderado: "Moderado",
          Elevado: "Elevado",
        },

        Aeroportos: "Aeroportos",
        EspacoAereo: "Espaço Aéreo",
        NivelExperienciaTripulacao: "Nível de Experiência da Tripulação",
        CaracteristicasEOperacionalidadeDaAeronave: "Características e operacionalidade da aeronave",
        CondicoesAtmosfericas: "Condições Atmosféricas",

        botaoGerarAvaliacao: "Gerar Avaliação",

        placeholder:{
          SelecioneUmaOpcao: "Selecione uma opção",
        }
      },

      tituloQuestao1QuaoAlertaVoceEsta: "Questão 1: Quão alerta você acha que está? (Considere sua condição antes de assumir a jornada)",

      tituloQuestao2VoceTeveSonoAdequado: "Questão 2: Você teve um sono adequado?",

      QuantoTempoDormiuNas24HorasAnteriores: "No início da jornada, por quanto tempo dormiu nas 24 horas anteriores?",

      QuantoTempoDormiuNas48HorasAnteriores: "No início da jornada, por quanto tempo dormiu nas 48 horas anteriores?",

      AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado: "Ao fim da jornada prevista, por quantas horas você terá permanecido acordado, descontado qualquer tempo alocado para repouso em acomodação adequada ou repouso a bordo quando compondo tripulação aumentada?",
      pontos: "pontos",

      tituloQuestao3QueHorasOcorreAPresenteJornada: "Questão 3: A que horas ocorre a presente jornada?",
      tituloQuestao4QualNivelDeRiscoOperacionalAssociado: "Questão 4: Qual o nível de risco operacional associado à jornada?",

      nota: "Nota",
      paragrafoSeORiscoElevadoEstiverPresenteInformarAoDespachoOperacional: "Se o Risco Elevado estiver presente, é recomendável considerar controles de risco tais como o cochilo, rotação de tarefa ou informar ao despacho operacional que você não se encontra apto para o serviço.",
      
      paragrafoPontuacao: "Pontuação",
      paragrafoSeORiscoElevadoEstiverPresenteInformarAoOperador: "Se o Risco Elevado estiver presente, é recomendável considerar controles de risco tais como o cochilo, rotação de tarefa ou informar ao operador que você não se encontra apto para o serviço.",

      rota: "Rota",
      aeroportos: "Aeroportos",
      espacoAereo: "Espaço Aéreo",
      nivelExperienciaTripulacao: "Nível de Experiência da Tripulação",
      caracteristicasEOperacionalidadeDaAeronave: "Características e operacionalidade da aeronave",
      condicoesAtmosfericas: "Condições Atmosféricas",

      tituloResultadoDosRiscos: "Resultado dos riscos",

      paragrafoOrientacaoAoTripulante: "Orientação ao Tripulante",

      paragrafoMecaONivelDeAlertaTripulacaoAumentada: "Meça o nível de alerta usando métodos objetivos e subjetivos e discuta com seu supervisor porque seu nível de alerta pode não ser suficiente para esta jornada e considere a possibilidade de ser escalado para outra jornada de forma a gerenciar o risco (por exemplo, em tripulação aumentada, período de repouso maior).",

      paragrafoMecaONivelDeAlertaChochilo: "Meça o nível de alerta usando métodos objetivos e subjetivos, discuta com seu supervisor se seu nível de alerta é adequado para esta jornada e considere o uso de estratégias de mitigação adicionais (por exemplo, cochilo, rotação de tarefa).",

      paragrafoMecaONivelDeAlertaCafeina: "Meça o nível de alerta usando métodos objetivos e subjetivos, discuta com seu supervisor se seu nível de alerta é adequado para esta jornada e considere controles de risco de fadiga benéficos para esta jornada (por exemplo, uso de cafeína, cuidado maior com a hidratação e alimentação).",
    },

  },

  ReportesDeFadigas: {

    ListaDeReportesDeFadigasAbertos: {
      tituloMotivo: "Motivo",
      tituloObservacoes: "Observações",
      botaoConfirmarVisualizacao: "Confirmar visualização",

      titulo: "Lista de reportes voluntários de fadigas - Abertos",

      tabela: {
        semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
        ID: "ID",
        Tripulante: "Tripulante",
        Data: "Data",
        Acoes: "Ações",
      }
    },

    ListaDeReportesDeFadigasFechados: {
      tituloMotivo: "Motivo",
      tituloObservacoes: "Observações",

      titulo: "Lista de reportes voluntários de fadigas - Fechados",

      tabela: {
        semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
        ID: "ID",
        Tripulante: "Tripulante",
        Data: "Data",
        Acoes: "Ações",
      }

    },

    AdicionarReporteDeFadiga: {
      titulo: "Reporte voluntário de fadiga",
      
      formulario: {
        Motivo: "Motivo",
        Data: "Data",
        OProblemaApresentadoPodeSerAlgoPontual: "O problema apresentado pode ser considerado Pontual, ou seja, é algo que permite o retorno às atividades no próximo dia de missão?",
        Observacoes: "Observações",

        botaoEnviarReporte: "Enviar reporte",

        placeholder: {
          SelecionarMotivo: "Selecionar motivo",
          SelecionarOpcao: "Selecionar opção",

        }
      }
    },

    EditarMotivosDeFadiga: {
      deletar: "Tem certeza que gostaria de deletar esse motivo de fadiga?",
      
      titulo: "Editar motivos de fadiga",

      formulario: {
        Nome: "Nome",

        placeholder: {
          NomeDoMotivoDeFadiga: "Nome do motivo de fadiga",
        }
      },

      tituloMotivosDeFadigaCadastrados: "Motivos de fadiga cadastrados",
      
      tabela: {
        Nome: "Nome",
        Acoes: "Ações",
      }
    },
  },

  PesquisaDeRelatorios: {
    titulo: "Pesquisa de relatórios",
    
    formulario: {
      AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
      Tripulantes135: "Tripulantes - 135",
      Tripulantes121: "Tripulantes - 121",
      Mecanicos: "Mecânicos",
      Coordenadores: "Coordenadores",
      DataInicial: "Data inicial",
      DataFinal: "Data final",
      MotivoDoEnvio: "Motivo do envio",
      Respondido: "Respondido",

      botaoProcurarQuestionarios: "Procurar questionários",

      placeholder: {
        SelecionarAplicabilidade: "Selecionar aplicabilidade",
        SelecionarTripulante: "Selecionar tripulante",
        SelecionarMecanico: "Selecionar mecânico",
        SelecionarCoordenador: "Selecionar coordenador",
        SelecionarMotivos: "Selecionar motivos",
        SelecionarStatus: "Selecionar status",
      }
    },

    tituloListaDeQuestionarios: "Lista de questionários",

    tabelaListaDeQuestionarios: {
      semQuestionarios: "Não há questionários cadastrados",
      Data: "Data",
      Colaborador: "Colaborador",
      Status: "Status",
      Motivo: "Motivo",
      Acoes: "Ações",
    },

    tituloDadosDoQuestionarioDeFadiga: "Dados do questionário de fadiga",
    tituloBotaoResultadoDaPesquisa: "Resultado da pesquisa",
    tituloBotaoAltResultadoDeProva: "Resultado de prova",
    botaoExportarCSV: "Exportar CSV",

    tabelaDadosDoQuestionario: {
      Pergunta: "Pergunta",
      Resposta: "Resposta",
    },
  },

  RelatorioAbastecimento: {

    ListaDeAbastecimentos: {
      lista: "Lista de abastecimentos",
      adicionar: "Adicionar abastecimento",
      editar: "Editar abastecimento",
      deletar: "Deletar abastecimento",

      tabela: {
        Data: "Data",
        Relatório: "N° do Relatório",
        Voo: "Nº do Voo",
        Aeronave: "Aeronave",
        Fornecedor: "Fornecedor",
        Localidade: "Localidade",
        Quantidade: "Quantidade",
        Acoes: "Ações",
      },

    },

    EditarAbastecimento: {
      titulo: "Editar abastecimento",
      dados: "Dados",
      formulario: {
        AnexarNotaFiscal: "Anexar nota fiscal",
        Aeronave: "Aeronave",
        Empresa: "Empresa",
        Relatorio: "Relatório",
        CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
        NumeroDaCe: "Número da CE",
        Trecho: "Trecho",
        Fornecedor: "Fornecedor",
        CombustivelAbastecido: "Combustível abastecido (L)",
        Localidade: "Localidade",
        Comandante: "Comandante",
        VendidoPara: "Vendido para",
        Endereco: "Endereço",
        Tipo: "Tipo",
        Reg: "Registro",
        Capt: "Comandante",
        InicioAbastecimento: "Início do abastecimento",
        Click: "Clique",
        TerminoAbastecimento: "Término do abastecimento",
        ProximaLocalidade: "Próxima localidade",
        NumeroHidrante: "N° hidrante",
        SeuNumeroDeVenda: "Seu n° de venda",
        NumeroDeVendaAnterior: "N° de venda anterior",
        LeituraInicial: "Leitura inicial",
        LeituraFinal: "Leitura final",
        Entregues: "Entregues",
        TipoCombustivel: "Tipo de combustível",
        Preco: "Preço.",
        Quantidade: "Quantidade",
        ValorUnitario: "Valor unitário",
        ValorTotal: "Valor total",
        ValorReembolsavel: "Valor reembolsável",
        ValorFinal: "Valor final",
        botaoEditarAbastecimento: "Editar abastecimento",
        placeholder: {
          SelecioneAeronave: "Selecione a aeronave",
          SelecioneRelatorio: "Selecione o relatório",
          SelecioneTrecho: "Selecione o trecho",
          SelecioneFornecedor: "Selecione o fornecedor de combustível",
          SelecioneLocal: "Selecione o local",
        }
      },
      aprovacoes: {
        titulo: "Aprovações",
        tabela: {
          Tipo: "Tipo",
          Aprovacao: "Aprovação",
          Acoes: "Ações",
        },
        modalReprovar: {
          Titulo: "Reprovar",
          TituloPorLogin: "Reprovar Por Login",
          TituloPorAssinatura: "Reprovar Por Assinatura Eletrônica",
          Razao: "Razão da reprovação",
          BotaoReprovar: "Reprovar abastecimento",
          Confirmacao: "Tem certeza que deseja reprovar este abastecimento?",
          AlertaAssinaturaVazia: "É necessário assinar digitalmente antes de reprovasr",
        },
        modalAprovar: {
          Titulo: "Aprovar",
          TituloPorLogin: "Aprovar Por Login",
          TituloPorAssinatura: "Aprovar Por Assinatura Eletrônica",
          BotaoAprovar: "Aprovar abastecimento",
          Confirmacao: "Tem certeza que deseja aprovar este abastecimento?",
          AlertaAssinaturaVazia: "É necessário assinar digitalmente antes de aprovar",
        }
      }
    },

    AdicionarAbastecimento: {
      deletar: "Tem certeza que deseja excluir esse abastecimento?",
      titulo: "Cadastrar abastecimento",
      formulario: {
        AnexarNotaFiscal: "Anexar nota fiscal",
        Aeronave: "Aeronave",
        Empresa: "Empresa",
        Relatorio: "Relatório",
        CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
        NumeroDaCe: "Número da CE",
        Trecho: "Trecho",
        Fornecedor: "Fornecedor",
        CombustivelAbastecido: "Combustível abastecido (L)",
        Localidade: "Localidade",
        Comandante: "Comandante",
        VendidoPara: "Vendido para",
        Endereco: "Endereço",
        Tipo: "Tipo",
        Reg: "Registro",
        Capt: "Comandante",
        InicioAbastecimento: "Início do abastecimento",
        Click: "Clique",
        TerminoAbastecimento: "Término do abastecimento",
        ProximaLocalidade: "Próxima localidade",
        NumeroHidrante: "N° hidrante",
        SeuNumeroDeVenda: "Seu n° de venda",
        NumeroDeVendaAnterior: "N° de venda anterior",
        LeituraInicial: "Leitura inicial",
        LeituraFinal: "Leitura final",
        Entregues: "Entregues",
        TipoCombustivel: "Tipo de combustível",
        Preco: "Preço.",
        Quantidade: "Quantidade",
        ValorTotal: "Valor total",
        botaoAdicionarAbastecimento: "Adicionar abastecimento",
        placeholder: {
          SelecioneAeronave: "Selecione a aeronave",
          SelecioneRelatorio: "Selecione o relatório",
          SelecioneTrecho: "Selecione o trecho",
          SelecioneFornecedor: "Selecione o fornecedor de combustível",
          SelecioneLocal: "Selecione o local",
        }
      },

      tabela: {
        Trecho: "Trecho",
        NumeroDaCe: "Nº da CE",
        Fornecedor: "Fornecedor",
        Localidade: "Localidade",
        QuantidadeSolicitada: "Quantidade solicitada",
        QuantidadeAbastecida: "Quantidade abastecida",
        Acoes: "Ações",
      },

      modalEditarAbastecimento: {
        titulo: "Editar solicitação de combustível",
        formulario: {
          CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
          NumeroDaCe: "Número da CE",
          Trecho: "Trecho",
          Fornecedor: "Fornecedor",
          CombustivelAbastecido: "Combustível abastecido (L)",
          Localidade: "Localidade",
  
          botaoEditarAbastecimento: "Editar abastecimento",
    
        },
      },

    },
  },

  RelatoriosDeVoo: {

    ListaDeRelatoriosDeVoo: {

      titulo: "Relatórios de voo",
      tituloOffLine: "Relatórios de voo - Offline",
      botaoAdicionarRelatorioDeVoo: "Adicionar relatório de voo",

      formulario: {
        botaoMudarData: "Mudar data",
      },

      tabela: {
        semRelatorios: "Não há relatórios cadastrados",
        NumeroDoRelatorio: "Número do relatório",
        ID: "ID",
        Base: "Base",
        Data: "Data",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Cliente: "Cliente",
        TipoDeVoo: "Tipo de voo",
        NumeroDoVoo: "Número do voo",
        Status: "Status",
        Acoes: "Ações",
      }
    },

    AdicionarRelatorioDeVoo: {
      titulo: "Cadastrar novo relatório de voo",
      
      formulario: {
        Data: "Data",
        Prefixo: "Prefixo",
        Voo: "Vôo",
        NumeroDeVoo: "Número de voo",
        NumeroDoRelatorio: "Número do relatório",
        SolicitouIsencao: "Solicitou isenção",
        Base: "Base",
        Contrato: "Contrato",
        MecanicoResponsavel: "Mecânico responsável",
        Cliente: "Cliente",
        Observacoes: "Observações",
        
        botaoCriarRelatorioDeVoo: "Criar relatório de voo",
      }
    },

    EditarRelatoriosDeVoo: {

      trocarStatusDoRelatorioDeVoo: "Tem certeza que gostaria de trocar o status do relatório de voo?",

      mensagemOfflineSemVoo: "Este voo não foi registrado offline e não pode ser editado.",

      confirmarSalvarTodos: "Deseja salvar todos os trechos?",

      infoOffline: "O sistema está offline. Aguarde o retorno da conexão para salvar os trechos.",

      titulo: "Editar relatório de voo",

      botaoRelatorio: "Relatório",
      botaoExtratoDB: "Extrato DB",
      botaoXML: "XML",

      botaoRelatorioDeVoo: {
        TrocarParaRascunho: "Trocar para rascunho",
        TrocarParaFinalizado: "Trocar para finalizado",
        TrocarParaCancelado: "Trocar para Cancelado",
      },

      erros: "Os seguintes erros de preenchimento impediram o relatório de ser finalizado",

      erros_salvar: "Os seguintes erros de preenchimento impediram o(s) trecho(s) de serem salvos",

      modalDiscrepanciaHorarios: {
        titulo: "Discrepância de horários preenchidos nos trechos com os recebidos do Flight Following",
        substituir: "Tem certeza que gostaria de substituir os horários do trecho pelos do Flight Following?",
        substituirTodos: "Tem certeza que gostaria de substituir os horários de todos os trechos pelos do Flight Following?",
        botaoSubstituir: 'Substituir',
        botaoSubstituirTodos: "Substituir todos os horários preenchidos pelos do Flight Following",
        ignorar: "Tem certeza que gostaria de manter os horários do trecho e ignorar os do Flight Following?",
        ignorarTodos: "Tem certeza que gostaria de manter os horários de todos os trechos e ignorar os do Flight Following?",
        botaoIgnorar: 'Ignorar',
        botaoIgnorarTodos: "Ignorar todos os horários do Flight Following e manter os preenchidos",
        tabela: {
          ID: "ID",
          Trecho: "Trecho",
          FlightFollowing: "Flight Following",
          Preenchido: "Preenchido",
          Partida: "Partida",
          Decolagem: "Decolagem",
          Pouso: "Pouso",
          Corte: "Corte",
          Acoes: "Ações",
          botaoSubstituir: "Substituir",
          botaoIgnorar: "Ignorar",
        },
      },

      formularioEditarRelatorio: {
        Data: "Data",
        Prefixo: "Prefixo",
        Voo: "Vôo",
        NumeroDeVoo: "Número de voo",
        NumeroDoRelatorio: "Número do relatório",
        SolicitouIsencao: "Solicitou isenção",
        Base: "Base",
        Contrato: "Contrato",
        MecanicoResponsavel: "Mecânico responsável",
        Cliente: "Cliente",
        Observacoes: "Observações",
        
        botaoEditarRelatorioDeVoo: "Editar relatório de voo",
      },

      tabelaVoosDia: {
        Titulo: "Outros voos do dia",
        SemVoos: "Não há outros voos no dia",
        Id: "Id",
        NumeroVoo: "Número do Voo",
        NumeroRelatório: "Número do Relatório",
        DecolagemPrevista: "Decolagem Prevista",
        Origem: "Origem",
        Cliente: "Cliente",
        Contrato: "Contrato",
        TipoVoo: "Tipo de Voo",
        Status: "Status",
      },

      excluirTripulante: "Tem certeza que deseja excluir esse tripulante? Ele será excluido de todos os trechos.",

      tituloCadastrarTripulacao: "Cadastrar tripulação",

      formularioCadastrarTripulacao: {
        Tripulante: "Tripulante",
        FuncaoDeBordo: "Função de bordo",
        DataDeApresentacao: "Data de Apresentação",
        HoraDeApresentacao: "Hora de Apresentação",

        botaoAdicionarTripulante: "Adicionar tripulante",
      },

      modalEditarTripulacao: {
        Titulo: "Editar Tripulante",
        FuncaoDeBordo: "Função de bordo",
        DataDeApresentacao: "Data de Apresentação",
        HoraDeApresentacao: "Hora de Apresentação",
        botaoEditarTripulante: "Editar tripulante",
      },

      tituloTripulantesCadastrados: "Tripulantes cadastrados",

      tabelaTripulantesCadastrados: {
        Nome: "Nome",
        CANAC: "CANAC",
        SISPAT: "SISPAT",
        FB: "FB",
        Apresentacao: "Apresentação",
        DecolagemPouso: "Decolagem/Pouso",
        TempoTotal: "Tempo Total",
        Navegacao: "Navegação",
        Instrumento: "Instrumento",
        Noturno: "Noturno",
        PousosDiurnos: "Pousos Diurnos",
        PousosNoturnos: "Pousos Noturnos",
        Pax: "Pax.",
        Carga: "Carga",
        Consumo: "Consumo",
        LongLine: "Long Line",
        ShortLine: "Short Line",
        Acoes: "Ações",
      },

      tituloCadastrarTrecho: "Cadastrar trecho",
      botaoSalvarTodos: "Salvar todos os trechos",

      formularioCadastrarTrecho: {
        Origem: "Origem",
        Destino: "Destino",
        Partida: "Partida",
        DEC: "DEC.",
        POU: "POU.",
        Corte: "Corte",
        DECPOU: "DEC-POU",
        Total: "Total",
        Nav: "Nav.",
        IFR: "IFR",
        Noturno: "Noturno",
        Diurnos: "Diurnos",
        Noturnos: "Noturnos",
        Partidas: "Partidas",
        PAX: "PAX",
        Carga: "Carga",
        LongLine: "Long line",
        ShortLine: "ShortLine",
        Inicial: "Inicial",
        Final: "Final",
        CodigoPTBR: "Código PTBR",

        botaoAdicionarTrecho: "Adicionar trecho",
      },

      tabelaCadastrarTrecho: {
        Realizados: "Realizados",
        Pousos: "Pousos",
        Dados: "Dados",
        CargaExterna: "Carga externa",
        Combustivel: "Combustível",
        OperacaoPTBR: "Operação PTBR",
        Acoes: "Ações",
        Numero: "N°",
        Origem: "Origem",
        Destino: "Destino",
        Partida: "Partida",
        DEC: "DEC.",
        POU: "POU.",
        Corte: "Corte",
        DECPOU: "DEC-POU",
        Total: "Total",
        Nav: "Nav.",
        IFR: "IFR",
        Noturno: "Noturno",
        Diurnos: "Diurnos",
        Noturnos: "Noturnos",
        Partidas: "Partidas",
        PAX: "PAX",
        Carga: "Carga",
        LongLine: "Long Line",
        ShortLine: "Short Line",
        Inicial: "Inicial",
        Final: "Final",
        CodigoPTBR: "Código PTBR",
      },

      tituloTotaisDosTrechos: "Totais dos trechos",

      tabelaTotaisDosTrechos: {
        DecolagemPouso: "Decolagem/Pouso",
        TempoTotal: "Tempo total",
        Navegacao: "Navegação",
        Instrumento: "Instrumento",
        Noturno: "Noturno",
        PousosDiurnos: "Pousos Diurnos",
        PousosNoturnos: "Pousos Noturnos",
        Pax: "Pax.",
        Carga: "Carga",
        Consumo: "Consumo",
      },

      excluirTrecho: "Tem certeza que deseja excluir esse trecho?",

      removerTripulanteDoTrecho: "Tem certeza que gostaria de remover este tripulante deste trecho?",

      tituloEdicaoTrecho: "Edição de Trecho",
      
      formularioEditarTrecho: {
        Origem: "Origem",
        Destino: "Destino",
        Partida: "Partida",
        DEC: "DEC.",
        POU: "POU.",
        Corte: "Corte",
        DECPOU: "DEC-POU",
        Total: "Total",
        Nav: "Nav.",
        IFR: "IFR",
        Noturno: "Noturno",
        Diurnos: "Diurnos",
        Noturnos: "Noturnos",
        Partidas: "Partidas",
        PAX: "PAX",
        Carga: "Carga",
        LongLine: "Long Line",
        ShortLine: "Short Line",
        Inicial: "Inicial",
        Final: "Final",
        CodigoPTBR: "Código PTBR",
        Horario: 'Horário',
        Copiar: 'Copiar',
        Atual: 'Hr.Atual',
        Following: 'F. Follow',
        FollowingShort: 'Follow',
        botaoEditarTrecho: "Editar trecho",
        limparTrecho: "As edições do trecho foram apagadas.",
      },

      tituloTripulacaoCadastrada: "Tripulação cadastrada",

      formularioAdicionarTripulante: {
        Tripulante: "Tripulante",
        FuncaoDeBordo: "Função de bordo",
        
        botaoAdicionarTripulante: "Adicionar tripulante",
      },

      tabelaTripulantes: {
        Nome: "Nome",
        FuncaoDeBordo: "Função de bordo",
        Acoes: "Ações",
      },

      excluirAbastecimento: "Tem certeza que deseja excluir esse abastecimento?",
      mensagemDadosAtualizadosComSucesso: "Dados atualizados com sucesso",

      tituloCadastrarAbastecimento: "Cadastrar abastecimento",
      
      formularioAdicionarAbastecimento: {
        CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
        Trecho: "Trecho",
        NumeroDaCE: "Número da CE",
        Fornecedor: "Fornecedor",
        CombustivelAbastecido: "Combustível abastecido (L)",
        Localidade: "Localidade",
        
        botaoAdicionarAbastecimento: "Adicionar abastecimento",

      },

      tituloAbastecimentosCadastrados: "Abastecimentos cadastrados",

      tabelaAbastecimentosCadastrados: {
        Trecho: "Trecho",
        NumeroDaCE: "Nº da CE",
        Cia: "Cia.",
        QuantidadeSolicitada: "Quantidade solicitada",
        QuantidadeAbastecida: "Quantidade abastecida",
        Acoes: "Ações",
      },

      tituloEditarSolicitacaoDeCombustivel: "Editar solicitação de combustível",

      formularioEditarSolicitacaoDeCombustivel: {
        CombustivelSolicitado: "Combustível Solicitado",
        Trecho: "Trecho",
        NumeroDaCE: "Número da CE",
        Fornecedor: "Fornecedor",
        CombustivelAbastecido: "Combustível abastecido (L)",
        Localidade: "Localidade",
        
        botaoEditarAbastecimento: "Editar abastecimento",
      },

      tituloObservacoes: "Observações",

      formularioEditarObservacoes: {
        Observacoes: "Observações",

        botaoEditarObservacoes: "Editar observações",
      },

      tituloAlertasDoRelatorio: "Alertas do Relatório",

      tabelaAlertasDoRelatorio: {
        Mensagem: "Mensagem",
        Data: "Data",
      },

      aprovarRelatorio: "Tem certeza que deseja aprovar este relatório?",
      reabrirRelatorio: "Tem certeza que deseja reabrir este relatório?",
      reprovarRelatorio: "Tem certeza que deseja reprovar este relatório?",

      relatorioReabertoGerouImplicacoes: "Este relatório foi reaberto! Isso gerou as seguintes implicações",

      tabelaImplicacoes: {
        Mensagem: "Mensagem",
        Data: "Data",
      },

      tituloAprovacoes: "Aprovações",

      botaoReabrirRelatorio: "Reabrir relatório",
      
      tabelaAprovacoes: {
        Tipo: "Tipo",
        Tripulante: "Tripulante",
        Aprovacao: "Aprovação",
        Acoes: "Ações",
      },

      tituloJustificativaReprovacao: "Justificativa de reprovação",

      formularioReprovacao: {
        RazaoDaReprovacao: "Razão da reprovação",
        botaoReprovarRelatorio: "Reprovar relatório",
      },

      tituloLoginDoComandanteNoLDAP: "Login do comandante no LDAP",

      formularioLogin: {

        botaoAcessarSistema: "Acessar o sistema",

        placeholder: {
          Email: "Seu e-mail",
          Senha: "Sua senha",
        }
      },

      tituloLogDoRelatorio: "Log do relatório",

      tabelaLogRelatorio: {
        Usuario: "Usuário",
        Acao: "Ação",
        Descricao: "Descrição",
        Data: "Data",
      }
    },
    
    ListaDeRelatoriosDeVooOffline: {

      titulo: "Relatórios de voo",

      tabela: {
        semRelatorios: "Não há relatórios cadastrados",
        ID: "ID",
        NumeroDoRelatorio: "Número do relatório",
        Base: "Base",
        Data: "Data",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Cliente: "Cliente",
        TipoDeVoo: "Tipo de voo",
        NumeroDoVoo: "Número do voo",
        Status: "Status",
        Acoes: "Ações",
      }
    },

    EditarRelatoriosDeVooOffline: {

      trocarStatusDoRelatorioDeVoo: "Tem certeza que gostaria de trocar o status do relatório de voo?",

      confirmarSalvarTodos: "Deseja salvar todos os trechos?",

      titulo: "Editar relatório de voo",

      botaoRelatorio: "Relatório",
      botaoExtratoDB: "Extrato DB",
      botaoXML: "XML",

      botaoRelatorioDeVoo: {
        TrocarParaRascunho: "Trocar para rascunho",
        TrocarParaFinalizado: "Trocar para finalizado",
        TrocarParaCancelado: "Trocar para Cancelado",
      },

      erros: "Os seguintes erros de preenchimento impediram o relatório de ser finalizado",

      formularioEditarRelatorio: {
        Data: "Data",
        Prefixo: "Prefixo",
        Voo: "Vôo",
        NumeroDeVoo: "Número de voo",
        NumeroDoRelatorio: "Número do relatório",
        SolicitouIsencao: "Solicitou isenção",
        Base: "Base",
        Contrato: "Contrato",
        MecanicoResponsavel: "Mecânico responsável",
        Cliente: "Cliente",
        Observacoes: "Observações",
        
        botaoEditarRelatorioDeVoo: "Editar relatório de voo",
      },

      excluirTripulante: "Tem certeza que deseja excluir esse tripulante? Ele será excluido de todos os trechos.",

      tituloCadastrarTripulacao: "Cadastrar tripulação",

      formularioCadastrarTripulacao: {
        Tripulante: "Tripulante",
        FuncaoDeBordo: "Função de bordo",
        DataDeApresentacao: "Data de Apresentação",
        HoraDeApresentacao: "Hora de Apresentação",

        botaoAdicionarTripulante: "Adicionar tripulante",
      },

      tituloTripulantesCadastrados: "Tripulantes cadastrados",

      tabelaTripulantesCadastrados: {
        Nome: "Nome",
        CANAC: "CANAC",
        SISPAT: "SISPAT",
        FB: "FB",
        Apresentacao: "Apresentação",
        DecolagemPouso: "Decolagem/Pouso",
        TempoTotal: "Tempo Total",
        Navegacao: "Navegação",
        Instrumento: "Instrumento",
        Noturno: "Noturno",
        PousosDiurnos: "Pousos Diurnos",
        PousosNoturnos: "Pousos Noturnos",
        Pax: "Pax.",
        Carga: "Carga",
        Consumo: "Consumo",
        LongLine: "Long Line",
        ShortLine: "Short Line",
        Acoes: "Ações",
      },

      tituloCadastrarTrecho: "Cadastrar trecho",
      botaoSalvarTodos: "Salvar todos os trechos",

      formularioCadastrarTrecho: {
        Origem: "Origem",
        Destino: "Destino",
        Partida: "Partida",
        DEC: "DEC.",
        POU: "POU.",
        Corte: "Corte",
        DECPOU: "DEC-POU",
        Total: "Total",
        Nav: "Nav.",
        IFR: "IFR",
        Noturno: "Noturno",
        Diurnos: "Diurnos",
        Noturnos: "Noturnos",
        Partidas: "Partidas",
        PAX: "PAX",
        Carga: "Carga",
        LongLine: "Long line",
        ShortLine: "ShortLine",
        Inicial: "Inicial",
        Final: "Final",
        CodigoPTBR: "Código PTBR",

        botaoAdicionarTrecho: "Adicionar trecho",
      },

      tabelaCadastrarTrecho: {
        Realizados: "Realizados",
        Pousos: "Pousos",
        Dados: "Dados",
        CargaExterna: "Carga externa",
        Combustivel: "Combustível",
        OperacaoPTBR: "Operação PTBR",
        Acoes: "Ações",
        Numero: "N°",
        Origem: "Origem",
        Destino: "Destino",
        Partida: "Partida",
        DEC: "DEC.",
        POU: "POU.",
        Corte: "Corte",
        DECPOU: "DEC-POU",
        Total: "Total",
        Nav: "Nav.",
        IFR: "IFR",
        Noturno: "Noturno",
        Diurnos: "Diurnos",
        Noturnos: "Noturnos",
        Partidas: "Partidas",
        PAX: "PAX",
        Carga: "Carga",
        LongLine: "Long Line",
        ShortLine: "Short Line",
        Inicial: "Inicial",
        Final: "Final",
        CodigoPTBR: "Código PTBR",
      },

      tituloTotaisDosTrechos: "Totais dos trechos",

      tabelaTotaisDosTrechos: {
        DecolagemPouso: "Decolagem/Pouso",
        TempoTotal: "Tempo total",
        Navegacao: "Navegação",
        Instrumento: "Instrumento",
        Noturno: "Noturno",
        PousosDiurnos: "Pousos Diurnos",
        PousosNoturnos: "Pousos Noturnos",
        Pax: "Pax.",
        Carga: "Carga",
        Consumo: "Consumo",
      },

      excluirTrecho: "Tem certeza que deseja excluir esse trecho?",

      removerTripulanteDoTrecho: "Tem certeza que gostaria de remover este tripulante deste trecho?",

      formularioEditarTrecho: {
        Origem: "Origem",
        Destino: "Destino",
        Partida: "Partida",
        DEC: "DEC.",
        POU: "POU.",
        Corte: "Corte",
        DECPOU: "DEC-POU",
        Total: "Total",
        Nav: "Nav.",
        IFR: "IFR",
        Noturno: "Noturno",
        Diurnos: "Diurnos",
        Noturnos: "Noturnos",
        Partidas: "Partidas",
        PAX: "PAX",
        Carga: "Carga",
        LongLine: "Long Line",
        ShortLine: "Short Line",
        Inicial: "Inicial",
        Final: "Final",
        CodigoPTBR: "Código PTBR",

        botaoEditarTrecho: "Editar trecho",
      },

      tituloTripulacaoCadastrada: "Tripulação cadastrada",

      formularioAdicionarTripulante: {
        Tripulante: "Tripulante",
        FuncaoDeBordo: "Função de bordo",
        
        botaoAdicionarTripulante: "Adicionar tripulante",
      },

      tabelaTripulantes: {
        Nome: "Nome",
        FuncaoDeBordo: "Função de bordo",
        Acoes: "Ações",
      },

      excluirAbastecimento: "Tem certeza que deseja excluir esse abastecimento?",
      mensagemDadosAtualizadosComSucesso: "Dados atualizados com sucesso",

      tituloCadastrarAbastecimento: "Cadastrar abastecimento",
      
      formularioAdicionarAbastecimento: {
        CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
        Trecho: "Trecho",
        NumeroDaCE: "Número da CE",
        Cia: "Cia.",
        CombustivelAbastecido: "Combustível abastecido (L)",
        
        botaoAdicionarAbastecimento: "Adicionar abastecimento",

      },

      tituloAbastecimentosCadastrados: "Abastecimentos cadastrados",

      tabelaAbastecimentosCadastrados: {
        Trecho: "Trecho",
        NumeroDaCE: "Nº da CE",
        Cia: "Cia.",
        QuantidadeSolicitada: "Quantidade solicitada",
        QuantidadeAbastecida: "Quantidade abastecida",
        Acoes: "Ações",
      },

      tituloEditarSolicitacaoDeCombustivel: "Editar solicitação de combustível",

      formularioEditarSolicitacaoDeCombustivel: {
        CombustivelSolicitado: "Combustível Solicitado",
        Trecho: "Trecho",
        NumeroDaCE: "Número da CE",
        Cia: "Cia.",
        CombustivelAbastecido: "Combustível abastecido (L)",
        
        botaoEditarAbastecimento: "Editar abastecimento",
      },

      tituloObservacoes: "Observações",

      formularioEditarObservacoes: {
        Observacoes: "Observações",

        botaoEditarObservacoes: "Editar observações",
      },

      tituloAlertasDoRelatorio: "Alertas do Relatório",

      tabelaAlertasDoRelatorio: {
        Mensagem: "Mensagem",
        Data: "Data",
      },

      aprovarRelatorio: "Tem certeza que deseja aprovar este relatório?",
      reabrirRelatorio: "Tem certeza que deseja reabrir este relatório?",
      reprovarRelatorio: "Tem certeza que deseja reprovar este relatório?",

      relatorioReabertoGerouImplicacoes: "Este relatório foi reaberto! Isso gerou as seguintes implicações",

      tabelaImplicacoes: {
        Mensagem: "Mensagem",
        Data: "Data",
      },

      tituloAprovacoes: "Aprovações",

      botaoReabrirRelatorio: "Reabrir relatório",
      
      tabelaAprovacoes: {
        Tipo: "Tipo",
        Tripulante: "Tripulante",
        Aprovacao: "Aprovação",
        Acoes: "Ações",
      },

      tituloJustificativaReprovacao: "Justificativa de reprovação",

      formularioReprovacao: {
        RazaoDaReprovacao: "Razão da reprovação",
        botaoReprovarRelatorio: "Reprovar relatório",
      },

      tituloLoginDoComandanteNoLDAP: "Login do comandante no LDAP",

      formularioLogin: {

        botaoAcessarSistema: "Acessar o sistema",

        placeholder: {
          Email: "Seu e-mail",
          Senha: "Sua senha",
        }
      },

      tituloLogDoRelatorio: "Log do relatório",

      tabelaLogRelatorio: {
        Usuario: "Usuário",
        Acao: "Ação",
        Descricao: "Descrição",
        Data: "Data",
      }
    },

    AdicionarRelatorioDeVooOffline: {
      titulo: "Cadastrar novo relatório de voo",
      
      formulario: {
        Data: "Data",
        Prefixo: "Prefixo",
        Voo: "Vôo",
        NumeroDeVoo: "Número de voo",
        SolicitouIsencao: "Solicitou isenção",
        Base: "Base",
        Contrato: "Contrato",
        MecanicoResponsavel: "Mecânico responsável",
        Cliente: "Cliente",
        Observacoes: "Observações",
        
        botaoCriarRelatorioDeVoo: "Criar relatório de voo",
      }
    },

    RelatoriosPendentesDeAprovacao: {
      aprovar: "Tem certeza que deseja aprovar este relatório?",

      titulo: "Relatórios Pendentes de Aprovação",

      formulario: {
        Base: "Base",
        Status: "Status",
      },

      botaoAprovar: "APROVAR",
      
      tabela: {
        Data: "Data",
        Base: "Base",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Contrato: "Contrato",
        TipoDeVoo: "Tipo de Voo",
        NumeroDoVoo: "N° do Voo",
        Status: "Status",
        Acoes: "Ações",
      }

    },

    QuantidadeDeVoosPorDia: {
      titulo: "Quantidade de voos por dia",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Base: "Base",
        Tripulantes: "Tripulantes",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        SomenteAprovados: "Somente aprovados",
        BaseContratual: "Base Contratual",
      },

      tituloTotaisDaAeronavePorData: "Totais da aeronave por data",

      tabelaTotaisDaAeronavePorData: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        QuantidadeDeVoos: "Quantidade de Voos",
        QuantidadeDePousos: "Quantidade de Pousos",
        QuantidadeDeCortes: "Quantidade de Cortes",
        QuantidadeDePAX: "Quantidade de PAX",
      },

      tituloTotaisDaAeronavePorPeriodo: "Totais da aeronave por período",

      tabelaTotaisDaAeronavePorPeriodo: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Prefixo: "Prefixo",
        Frota: "Frota",
        QuantidadeDeVoos: "Quantidade de Voos",
        QuantidadeDePousos: "Quantidade de Pousos",
        QuantidadeDeCortes: "Quantidade de Cortes",
        QuantidadeDePAX: "Quantidade de PAX",
      },

      tituloTotaisDoModeloPorData: "Totais do modelo por data",

      tabelaTotaisDoModeloPorData: {
        Data: "Data",
        Frota: "Frota",
        QuantidadeDeVoos: "Quantidade de Voos",
        QuantidadeDePousos: "Quantidade de Pousos",
        QuantidadeDeCortes: "Quantidade de Cortes",
        QuantidadeDePAX: "Quantidade de PAX",
      },

      tituloTotaisDoModeloPorPeriodo: "Totais do modelo por período",

      tabelaTotaisDoModeloPorPeriodo: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Frota: "Frota",
        QuantidadeDeVoos: "Quantidade de Voos",
        QuantidadeDePousos: "Quantidade de Pousos",
        QuantidadeDeCortes: "Quantidade de Cortes",
        QuantidadeDePAX: "Quantidade de PAX",
      },

      tituloTotalGeralPorData: "Total Geral por data",

      tabelaTotalGeralPorData: {
        Data: "Data",
        QuantidadeDeVoos: "Quantidade de Voos",
        QuantidadeDePousos: "Quantidade de Pousos",
        QuantidadeDeCortes: "Quantidade de Cortes",
        QuantidadeDePAX: "Quantidade de PAX",
      },

      tituloTotalGeralPorPeriodo: "Total Geral por período",

      tabelaTotalGeralPorPeriodo: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Base: "Base",
        QuantidadeDeVoos: "Quantidade de Voos",
        QuantidadeDePousos: "Quantidade de Pousos",
        QuantidadeDeCortes: "Quantidade de Cortes",
        QuantidadeDePAX: "Quantidade de PAX",
      }

    },

    RelatorioDeOcorrenciasAnormais: {
      titulo: "Relatório de Ocorrências Anormais",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        RelatorioDeVoo: "Relatório de Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",

        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
        }
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        TipoDeOcorrencia: "Tipo de Ocorrência",
        DescricaoDaOcorrencia: "Descrição da Ocorrência",
        AcaoRequerida: "Ação Requerida",
        Observacoes: "Observações",
        Tripulantes: "Tripulantes",
      }

    },

    ControleDiarioDeUtilizacaoDeAeronavesContratadas: {
      osCamposDataClienteEBaseSaoObrigatoriosParaExportacaoEmPDF: "Os campos Data, Cliente e Base são obrigatórios para exportação em PDF.",

      titulo: "Controle Diário de Utilização de Aeronaves Contratadas",

      formulario: {
        Data: "Data",
        SomenteAprovados: "Somente aprovados",
        Base: "Base",
        Aeronave: "Aeronave",
        Contrato: "Contrato",
        Cliente: "Cliente",
        BaseContratual: "Base Contratual",
      },

      tabela: {
        Prefixo: "Prefixo",
        Frota: "Frota",
        Contrato: "Contrato",
        CodigoSAP: "Código SAP",
        TempoTotalDeVooNaDataDecolagemAoPouso: "Tempo Total de Voo na Data - Decolagem ao Pouso",
        TempoTotalDeVooNoDataPartidaAoCorte: "Tempo Total de Voo no Data - Partida ao Corte",
        IndisponibilidadesMotivos: "Indisponibilidades - Motivos",
        IndisponibilidadesHoras: "Indisponibilidades - Horas",
      }
    },

    BoletimDeDisponibilidade: {
      titulo: "Boletim de disponibilidade",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Contrato: "Contrato",
        SomenteAprovados: "Somente aprovados",
        BaseContratual: "Base Contratual",
      },

      tabela: {
        Contrato: "Contrato",
        Prefixo: "Prefixo",
        Data: "Data",
        TipoDeContrato: "Tipo de Contrato",
        VooDecolagemAoPouso: "Voo - Decolagem ao Pouso",
        VooPartidaAoCorte: "Voo - Partida ao Corte",
        QtdPousos: "Qtd. Pousos",
        QtdPartidas: "Qtd. Partidas",
        VooTotalDecolagemAoPouso: "Voo Total - Decolagem ao Pouso",
        DuracaoMediaDeVooDecolagemAoPouso: "Duração Média de Voo - Decolagem ao Pouso",
        VooTotalPartidaAoCorte: "Voo Total - Partida ao Corte",
        DuracaoMediaDeVooPartidaAoCorte: "Duração Média de Voo - Partida ao Corte",
        MaximoDeDisponibilidadeContratual: "Máximo de Disponibilidade Contratual",
        IndisponibilidadeReal: "Indisponibilidade Real",
        IndisponibilidadeContratual: "Indisponibilidade Contratual",
        DisponibilidadeReal: "Disponibilidade Real",
        DisponibilidadeContratual: "Disponibilidade Contratual",
        TipoMPRG: "Tipo MPRG",
        TipoMNPR: "Tipo MNPR",
        TipoOPS: "Tipo OPS",
        OcorrenciaAnormal: "Ocorrência Anormal",
      },

      tituloTotais: "Totais",

      tabelaTotais: {
        Contrato: "Contrato",
        Prefixo: "Prefixo",
        TipoDeContrato: "Tipo de Contrato",
        QtdPousos: "Qtd. Pousos",
        QtdPartidas: "Qtd. Partidas",
        VooTotalDecolagemAoPouso: "Voo Total - Decolagem ao Pouso",
        VooTotalPartidaAoCorte: "Voo Total - Partida ao Corte",
        DuracaoMediaDeVooDecolagemAoPouso: "Duração Média de Voo - Decolagem ao Pouso",
        DuracaoMediaDeVooPartidaAoCorte: "Duração Média de Voo - Partida ao Corte",
        TempoTotalRegistrado: "Tempo Total Registrado",
        MaximoDeDisponibilidadeContratual: "Máximo de Disponibilidade Contratual",
        IndisponibilidadeReal: "Indisponibilidade Real",
        IndisponibilidadeContratual: "Indisponibilidade Contratual",
        DisponibilidadeReal: "Disponibilidade Real",
        DisponibilidadeContratual: "Disponibilidade Contratual",
        TipoMPRG: "Tipo MPRG",
        TipoMNPR: "Tipo MNPR",
        TipoOPS: "Tipo OPS",
        OcorrenciaAnormal: "Ocorrência Anormal",

        PorcentagemIndisponibilidadeReal: "% Indisponibilidade Real",
        PorcentagemIndisponibilidadeContratual: "% Indisponibilidade Contratual",
        PorcentagemDisponibilidadeReal: "% Disponibilidade Real",
        PorcentagemDisponibilidadeContratual: "% Disponibilidade Contratual",
        PorcentagemTipoMPRG: "% Tipo MPRG",
        PorcentagemTipoMNPR: "% Tipo MNPR",
        PorcentagemTipoOPS: "% Tipo OPS",
        PorcentagemAproveitamentoDecolagemAoPouso: "% Aproveitamento - Decolagem ao Pouso",
        PorcentagemAproveitamentoPartidaAoCorte: "% Aproveitamento - Partida ao Corte",
      }

    },

    FichasDeDisponibilidade: {
      titulo: "Fichas de disponibilidade",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Aeronave: "Aeronave",
        Contrato: "Contrato",
        Base: "Base",
      },

      tabela: {
        Prefixo: "Prefixo",
        Contrato: "Contrato",
        InicioDisponibilidadeContratual: "Início disp. contratual",
        FimDispContratual: "Fim disp. contratual",
        InicioIndisponibilidade: "Início indisp.",
        FimIndisponibilidade: "Fim indisp.",
        Franquia: "Franquia",
        IndisponibilidadeTotal: "Indisp. Total",
        SemFranquia: "Sem franquia",
        TempoTotal: "Tempo total",
      }
    },

    RelatorioDeConsumo: {
      titulo: "Relatório de Consumo",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        RelatorioDeVoo: "Relatório de Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroDeReciboDoCombustivel: "N° de Recibo do Combustível",
        FornecedorDeCombustivel: "Fornecedor de Combustível",
        BaseContratual: "Base Contratual",
        
        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
        }
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        Isencao: "Isenção",
        TotalVooDecolagemAoPouso: "Total Voo - Decolagem ao Pouso",
        TotalDoVooPartidaAoCorte: "Total do Voo - Partida ao Corte",
        TotalDoVooNavegacao: "Total do Voo - Navegação",
        TotalDoVooInstrumento: "Total do Voo - Instrumento",
        TotalDoVooNoturno: "Total do Voo - Noturno",
        TotalDoVooPartidas: "Total do Voo - Partidas",
        TotalDoVooPousosDiurnos: "Total do Voo - Pousos Diurnos",
        TotalDoVooPousosNoturnos: "Total do Voo - Pousos Noturnos",
        TotalDoVooPAX: "Total do Voo - PAX",
        TotalDoVooCarga: "Total do Voo - Carga",
        TipoDeContrato: "Tipo de Contrato",
        CombustivelAutorizado: "Combustível Autorizado",
        FornecedorDeCombustivel: "Fornecedor de Combustível",
        NumeroDaCE: "N° da CE",
        QuantidadeSolicitada: "Quantidade Solicitada",
        QuantidadeAbastecida: "Quantidade Abastecida",
        QuantidadeAbastecidaConvertida: "Quantidade Abastecida Convertida",
        Saldo: "Saldo",
        Consumo: "Consumo",
        ConsumoEmLitros: "Consumo em litros",
      },

      tituloTotais: "Totais",

      tabelaTotais: {
        Prefixo: "Prefixo",
        Frota: "Frota",
        TotalVooDecolagemAoPouso: "Total Voo - Decolagem ao Pouso",
        TotalDoVooPartidaAoCorte: "Total do Voo - Partida ao Corte",
        TotalDoVooNavegacao: "Total do Voo - Navegação",
        TotalDoVooInstrumento: "Total do Voo - Instrumento",
        TotalDoVooNoturno: "Total do Voo - Noturno",
        TotalDoVooPartidas: "Total do Voo - Partidas",
        TotalDoVooPousosDiurnos: "Total do Voo - Pousos Diurnos",
        TotalDoVooPousosNoturnos: "Total do Voo - Pousos Noturnos",
        TotalDoVooPAX: "Total do Voo - PAX",
        TotalDoVooCarga: "Total do Voo - Carga",
        CombustivelAutorizado: "Combustível Autorizado",
        QuantidadeSolicitada: "Quantidade Solicitada",
        QuantidadeAbastecida: "Quantidade Abastecida",
        QuantidadeAbastecidaConvertida: "Quantidade Abastecida Convertida",
        Saldo: "Saldo",
        Consumo: "Consumo",
        ConsumoEmLitros: "Consumo em litros",
      }
    },

    RelatorioDeDisponibilidadeDeCombustivel: {
      titulo: "Relatório de Disponibilidade de Combustível",

      formulario: {
        MesInicio: "Mês Início",
        MesTermino: "Mês Término",
        Aeronave: "Aeronave",
        Base: "Base",
        Cliente: "Cliente",
        SomenteAprovados: "Somente aprovados",
      },

      tabela: {
        Inicio: "Início",
        Fim: "Fim",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Contrato: "Contrato",
        Cliente: "Cliente",
        QuantidadeAbastecida: "Quantidade Abastecida",
        QuantidadeAbastecidaConvertida: "Quantidade Abastecida Convertida",
        Consumo: "Consumo",
        CAutorizado: "C. Autorizado",
        Saldo: "Saldo",
        HorasTotais: "Horas totais",
        Dias: "Dias",
        MediaDeHorasDeVooPorDia: "Média de Horas de Voo por Dia",
        MediaDeConsumoPorDia: "Média de Consumo por Dia",
        MediaDeConsumoPorHorasDeVoo: "Média de Consumo por Horas de voo",
      }

    },

    ExtratoDeDBEmBloco: {
      titulo: "Extrato de DB em bloco",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Aeronave: "Aeronave",
        Contrato: "Contrato",
        Base: "Base",
        BasesContratual: "Bases Contratual",
        SomenteAprovados: "Somente aprovados",
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
      }
      
    },

    RelatorioDePousosPorLocalidade: {
      titulo: "Relatório de Pousos por Localidade",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        Local: "Local",
        RelatorioDeVoo: "Relatório de Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",

        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
        }
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        Origem: "Origem",
        Destino: "Destino",
        Tripulantes: "Tripulantes",
        DEPARR: "DEP-ARR",
        Total: "Total",
        TotalDePousosDaAnvNaData: "Total de pousos da anv na data",
        TotalDePousosDaAnvNoPeriodo: "Total de pousos da anv no período",
        TotalDePousosDaFrotaNoPeriodo: "Total de pousos da frota no período",
        TotalDePousosGeralNoPeriodo: "Total de pousos geral no período",
      }


    },

    ApuracaoDeHoras: {
      titulo: "Apuração de horas",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Aeronave: "Aeronave",
        BaseContratual: "Base Contratual",
        Contrato: "Contrato",
        Cliente: "Cliente",
        Indisponibilidade: "Indisponibilidade",

        opcoesIndisponibilidade: {
          NaoExibir: "Não Exibir",
          ExibirApenasTotal: "Exibir apenas Total",
          ExibirApenasContratual: "Exibir apenas Contratual",
          ExibirTodas: "Exibir Todas",
        },

        SomenteAprovados: "Somente aprovados",
      },

      tabela: {
        Data: "Data",
        Contrato: "Contrato",
        PrefixoContratual: "Prefixo Contratual",
        Backup: "Backup",
        NumeroDoRelatorioDeVoo: "N° do Relatório de Voo",
        NumeroDoVoo: "N° do Voo",
        TipoDeContrato: "Tipo de Contrato",
        TempoTotalDeVooDecolagemAoPouso: "Tempo Total de Voo - Decolagem ao Pouso",
        TempoTotalDeVooPartidaAoCorte: "Tempo Total de Voo - Partida ao Corte",
        CombustivelConsumido: "Combustível consumido",
        CombustivelAbastecido: "Combustível abastecido",
        IndisponibilidadeDiariaTotal: "Indisponibilidade Diária - Total",
        IndisponibilidadeDiariaContratual: "Indisponibilidade Diária - Contratual",
      }

    },

    RelatorioDeTempoEmSolo: {
      titulo: "Relatório de Tempo em Solo",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        Local: "Local",
        Aeronave: "Aeronave",
        Frota: "Frota",
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        Origem: "Origem",
        Destino: "Destino",
        Tripulantes: "Tripulantes",
        DEPARR: "DEP-ARR",
        Total: "Total",
      }
    },

    RelatorioDeTempoEntreTrechos: {
      titulo: "Relatório de Tempo entre Trechos",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        RelatorioDeVoo: "Relatório de Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",
        
        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
        }
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        Tripulantes: "Tripulantes",
        QuantidadeDeTrechos: "Quantidade de trechos",
        TempoEntreTrechos: "Tempo entre Trechos",
        TotalDoVooDEPARR: "Total do Voo - DEP-ARR",
        TotalDoVooTempoTotal: "Total do Voo - Tempo Total",
      }

    },

    ControleGeralDeRelatorios: {
      titulo: "Controle Geral de Relatórios",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        AnaliticoOuSintetico: "Analítico ou Sintético",

        opcoesAnaliticoOuSintetico: {
          AnaliticoPorTripulante: "Analítico - Por Tripulante",
          AnaliticoPorRelatorio: "Analítico - Por Relatório",
          Sintetico: "Sintético",
        },

        SomenteAprovados: "Somente aprovados",
        RelatorioDeVoo: "Relatório de Voo",
        NumeroDoVoo: "N° do Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Isencao: "Isenção",
        CargaExterna: "Carga externa",
        Cliente: "Cliente",
        BasesContratual: "Bases Contratual",

        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
          InformeONumeroDoVoo: "Informe o número do voo",
        }
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        Isencao: "Isenção",
        TotalDoVooDEPARR: "Total do Voo - DEP-ARR",
        TotalDoVooTempoTotal: "Total do Voo - Tempo Total",
        TotalDoVooNavegacao: "Total do Voo - Navegação",
        TotalDoVooInstrumento: "Total do Voo - Instrumento",
        TotalDoVooNoturno: "Total do Voo - Noturno",
        TotalDoVooPousosDiurnos: "Total do Voo - Pousos Diurnos",
        TotalDoVooPousosNoturnos: "Total do Voo - Pousos Noturnos",
        TotalDoVooPAX: "Total do Voo - PAX",
        TotalDoVooCarga: "Total do Voo - Carga",
        TotalDoVooConsumo: "Total do Voo - Consumo",
        QuantidadeAbastecida: "Quantidade abastecida",
        Observacoes: "Observações",


        FB: "FB",
        Apresentacao: "Apresentação",
        Matricula: "Matrícula",
        Tripulante: "Tripulante",
        Etapa: "Etapa",
        Origem: "Origem",
        Destino: "Destino",
        HrPart: "Hr. Part.",
        DEP: "DEP.",
        ARR: "ARR.",
        Corte: "Corte",
        DEPARR: "DEP-ARR",
        TempoTotal: "Tempo - Total",
        TempoNavegacao: "Tempo - Navegação",
        TempoInstrumento: "Tempo - Instrumento",
        TempoNoturno: "Tempo - Noturno",
        PousosDiurnos: "Pousos - Diurnos",
        PousosNoturnos: "Pousos - Noturnos",
        Partidas: "Partidas",
        PAX: "PAX.",
        Carga: "Carga",
        CargaExternaLongLine: "Carga Externa - Long Line",
        CargaExternaShortLine: "Carga Externa - Short Line",
        CombustivelInicial: "Combustível - Inicial",
        CombustivelFinal: "Combustível - Final",
      }

    },

    ExtratoDeRelatorioDeVooEmBloco: {
      titulo: "Extrato de Relatório de Voo em bloco",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Aeronave: "Aeronave",
        Contrato: "Contrato",
        Base: "Base",
        Tripulantes: "Tripulantes",
        BasesContratual: "Bases Contratual",
        SomenteAprovados: "Somente aprovados",
        linguagem: "Linguagem",
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
      }

    },

    ConferenciaDeMedicao: {
      titulo: "Conferência de medição",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Contrato: "Contrato",
        Cliente: "Cliente",
        TipoDeMedicao: "Tipo de Medição",

        opcoesMedicao: {
          Sintetica: "Sintética",
          Analitica: "Analítica",
        },

        SomenteAprovados: "Somente aprovados",
        BaseContratual: "Base Contratual",
      },

      tabela: {
        Contrato: "Contrato",
        PrefixoContrato: "Prefixo contrato",
        Status: "Status",
        NumeroDoVoo: "N° do Voo",
        Cliente: "Cliente",
        CodigoPTBR: "Código PTBR",
        LocalidadeInicio: "Localidade - início",
        LocalidadeFim: "Localidade - fim",
        Prefixo: "Prefixo",
        Inicio: "Início",
        Fim: "Fim",
      }
    },

    RelatorioDeVoosComCargaExterna: {
      titulo: "Relatório de Voos com Carga Externa",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        RelatorioDeVoo: "Relatório de Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Tripulantes: "Tripulantes",

        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
        }
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
        Tripulantes: "Tripulantes",
        TotalDoVooDEPARR: "Total do Voo - DEP-ARR",
        TotalDoVooTempoTotal: "Total do Voo - Tempo Total",
        CargaExternaLongLine: "Carga Externa - Long Line",
        CargaExternaShortLine: "Carga Externa - Short Line",
      }

    },

    RelatorioDePontualidade: {
      titulo: "Relatório de Pontualidade",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Base: "Base",
        SomenteAprovados: "Somente aprovados",
        TipoDeAtraso: "Tipo de atraso",

        opcoesTiposDeAtraso: {
          Decolagem: "Decolagem",
          TempoDeVoo: "Tempo de voo",
        },
      },

      tabela: {
        EstatisticasDeVooDe(dataInicial, dataFinal){
          return `Estastísticas de Voo de ${dataInicial} a ${dataFinal}`
        },

        Tipo: "Tipo",
        Valor: "Valor",
        TempoTotalDeAtraso: "Tempo Total de Atraso",
        Atrasados: "Atrasados",
        Pontuais: "Pontuais",
        MediaTempo: "Média Tempo",
        Operacoes: "Operações",
        Coordenacao: "Coordenação",
        Despacho: "Despacho",
        Manutencao: "Manutenção",
        NumeroVoos: "Nº Voos",
        AtrasadosInterno: "Atrasados Int",
        AtrasadosExterno: "Atrasados Ext",
        Pontualidade: "Pontualidade",
        PontualidadeSemAtrasoExterno: "Pont (s/ atrasos ext)",
        PontualidadeSemAtrasoInterno: "Pont (s/ atrasos int)",
        VooManutencao: "Voo Manutenção",
        VooGiros: "Voo Giros",
        VooTreinamento: "Voo Treinamento",
        VooPTBR: "Voo PTBR",
        VooOutrosClientes: "Voo Outros Clientes",
        VoosComerciais: "Voos Comerciais",
      }

    },

    RelatorioDeAbastecimentos: {
      titulo: "Relatório de Abastecimentos",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        SomenteAprovados: "Somente aprovados",
        RelatorioDeVoo: "Relatório de Voo",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Base: "Base",
        TipoDeVoo: "Tipo de Voo",
        Contrato: "Contrato",
        NumeroDeReciboDoCombustivel: "N° de Recibo do Combustível",
        FornecedorDeCombustivel: "Fornecedor de Combustível",

        placeholder: {
          InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
          InformeONumeroDeReciboDoCombustivel: "Informe o número de recibo de combustível",
        }
      },

      tabela: {
        ID: "ID",
        Data: "Data",
        Aeronave: "Aeronave",
        Modelo: "Modelo",
        NumeroRelatorioDeVoo: "N° Relatório de Voo",
        TipoDeVoo: "Tipo de Voo",
        FornecedorDeCombustivel: "Fornecedor de Combustível",
        NumeroDoRecibo: "N° do Recibo",
        QuantidadeDeCombustivel: "Quantidade de Combustível",
      }

    },

    ExtracaoDeXMLEmBloco: {
      titulo: "Extração de XML em bloco",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Aeronave: "Aeronave",
        Cliente: "Cliente",
        Contrato: "Contrato",
        Base: "Base",
        SomenteAprovados: "Somente aprovados",
        BaseContratual: "Base Contratual",
      },

      tabela: {
        Data: "Data",
        Prefixo: "Prefixo",
        Frota: "Frota",
        Base: "Base",
        Contrato: "Contrato",
        Cliente: "Cliente",
        NumeroRelatorio: "N° Relatório",
        NumeroDoVoo: "N° do Voo",
      }

    },
  },

  Layout: {
    Topo: {
      bemvindo: "Bem-vindo,",
      
      botaoMinhaConta: "Minha Conta",
      botaoSair: "Sair",

      menuDadosBasicos: {
        tituloMenu: "Dados Básicos",

        FileDigital: "File Digital",
      },

      menuVoos: {
        tituloMenu: "Voos",
        Abastecimentos: "Abastecimentos",
        ListaDeAbastecimentos: "Lista de abastecimentos",
        CadastrarAbastecimentoAvulso: "Cadastrar abastecimento avulso",
        Relatorios: "Relatórios",
        Relatorios: "Relatórios",
        ListaDeRelatoriosDeVoo: "Lista de relatórios de voo",
        CadastrarRelatorioDeVoo: "Cadastrar relatório de voo",
        ListaDeRelatoriosDeVooOffline: "Lista de relatórios de voo offline",
        Controle: "Controle",
        VisualizarHoraDeVoo: "Visualizar hora de vôo",
        ControleGeralDeRelatorios: "Controle Geral de Relatórios",
        ExtratoDeDBEmBloco: "Extrato de DB em bloco",
        ExtratoDeRelatoriosEmBloco: "Extrato de Relatórios em bloco",
      },

      menuEscalas: {
        tituloMenu: "Escalas",

        EscalasDeMissao: "Escalas de Missão",
        EscalaDeMissao: "Escala de Missão",
        SolicitacoesDeEscala: "Solicitações de Escala",
        CadastrarSolicitacao: "Cadastrar Solicitação",
        ListaDeSolicitacoes: "Lista de Solicitações",
        EscalaDiaria: "Escala diária",
        ListaDeEscalasDiaria: "Lista de escalas diária",
      },

      menuTreinamentos: {
        tituloMenu: "Treinamentos",

        ComunicadosDeTreinamento: "Comunicados de Treinamento",
        ListaDeLogbooks: "Lista de logbooks",
      },

      menuPagamentos: {
        tituloMenu: "Pagamentos",

        Pagamentos: "Pagamentos",
        ExtratoPorReferencia: "Extrato por Referência",
        ExtratoPorPagamento: "Extrato por Pagamento",
        SolicitacoesDePagamento: "Solicitações de Pagamento",
        DeslocamentoDeMissao: "Deslocamento de Missão",
        DeslocamentoDeTreinamento: "Deslocamento de Treinamento",
        TransporteDeMissao: "Transporte de Missão",
        TransporteDeTreinamento: "Transporte de Treinamento",
      },

      menuFIRA: {
        tituloMenu: "FIRA",

        PapeletasIndividuaisFIRA: "Papeletas individuais (FIRA)",
        ListaDePapeletas: "Lista de Papeletas",
        Consulta: "Consulta",
        ControleDeFIRA: "Controle de FIRA",
      },

      menuFRMS: {
        tituloMenu: "FRMS",
        AdicionarDiscrepancia: "Discrepância técnica",
        RelatoriosDeFadiga: "Relatórios de fadiga",
        ListaDeRelatoriosDeFadigas: "Lista de relatórios de fadigas",
        CadastrarRelatoriosDeFadiga: "Cadastrar relatórios de fadiga",
        ReporteVoluntarioDeFadiga: "Reporte voluntário de fadiga",
        ReportarFadiga: "Reportar fadiga",
        FerramentaDeAuxilioParaAutoavaliacaoDaFadigaFAPA: "Ferramenta de Auxílio para Autoavaliação da Fadiga (FAPA)",
        Cadastrar: "Cadastrar",
      },

      menuPendencias: {
        OUsuarioNaoPossuiPendencias: "O usuário não possui pendências",
        Documentacao: "Documentação",
        Papeletas: "Papeletas",
        Escalas: "Escalas",
        Voos: "Voos",
        Treinamentos: "Treinamentos",
      },

      menuConfiguracoes: {
        App: "App",
        InstalacaoMobile: "Instalação Mobile",
        Diversos: "Diversos",
        LinksUteis: "Links Úteis",
      },

      atencaoVoceEstaUtilizandoOAmbienteDeHomologacao: "Atenção: Você está utilizando o ambiente de homologação",

    }
  },

  Miscelania: {
    Overlay: {
      paragrafoCarregando: "Carregando..."
    },

    RequestApi: {
      seuUsuarioNaoTemPermissaoParaAcessarEstaPagina: "Seu usuário não tem permissão para acessar esta página.",
      seuUsuarioNaoTemPermissaoParaAcessarEstaFuncionalidade: "Seu usuário não tem permissão para acessar esta funcionalidade.",
    },
  },

  Pagamentos: {
    Bases: {
      botaoLocalidades: "Localidades",

      titulo: "Bases",
      
      tabela: {
        Nome: "Nome",
        Tipo: "Tipo",
        CEP: "CEP",
        Base: "Base",

        botaoAssociarCEPAOrigem: "Associar CEP à origem",
        botaoAssociarCEPADestino: "Associar CEP à destino",

        Fornecedor: "Fornecedor",
      },
    },

    AdicionarSolicitacaoDePagamentoMissaoDeslocamento: {
      
      titulo: "Adicionar solicitação de pagamento - missão - deslocamento",

      formulario: {
        EscalaGrade: "Escala / Grade",
        Quantidade: "Quantidade",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Valor: "Valor",
        Moeda: "Moeda",
        ValorTotal: "Valor total",
        Observacao: "Observação",
        
        tituloTrechos: "Trechos",

        botaoAdicionarTrecho: "Adicionar Trecho",

        tabela: {
          BuscarLocais: "Buscar Locais",
          BaseOrigem: "Base Origem",
          FornecedorOrigem: "Fornecedor Origem",
          CEPOrigem: "CEP Origem",
          BaseDestino: "Base Destino",
          FornecedorDestino: "Fornecedor Destino",
          CEPDestino: "CEP Destino",
        },

        botaoCalcular: "Calcular",

        botaoSalvarSolicitacao: "Salvar solicitação",

        placeholder: {
          SelecionarEscala: "Selecionar escala",
          SelecionarMoeda: "Selecionar moeda",
          Observacao: "Observação",
        }
      }
    },

    SolicitacoesDePagamentoDeslocamentoMissao: {
      deletar: "Tem certeza que gostaria de deletar essa solicitação?",

      titulo: "Solicitações de Pagamento - Deslocamento - Missão",

      botaoSolicitarPagamentoDeDeslocamentoMissao: "Solicitar pagamento de deslocamento - Missão",

      tabela: {
        semSolicitacaoDePagamento: "Não há solicitação de pagamento cadastrada",
        ID: "ID",
        Status: "Status",
        Lote: "Lote",
        Frota: "Frota",
        Mes: "Mês",
        Revisao: "Revisão",
        Inicio: "Início",
        Fim: "Fim",
        Quantidade: "Quantidade",
        Valor: "Valor",
        ValorTotal: "Valor Total",
        Moeda: "Moeda",
        Observacao: "Observação",
        Acoes: "Ações",
      },

      tituloBases: "Bases",

      tabelaBases: {
        Origem: "Origem",
        CEPOrigem: "CEP Origem",
        Destino: "Destino",
        CEPDestino: "CEP Destino",
      },
    },

    AdicionarSolicitacaoDePagamentoMissaoTransporte: {
      titulo: "Adicionar solicitação de pagamento - missão - transporte",

      formulario: {
        EscalaGrade: "Escala / Grade",
        Quantidade: "Quantidade",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Valor: "Valor",
        Moeda: "Moeda",
        ValorTotal: "Valor total",
        Base: "Base",
        Observacao: "Observação",

        botaoSalvarPagamento: "Salvar pagamento",

        placeholder: {
          SelecionarEscala: "Selecionar escala",
          SelecionarMoeda: "Selecionar moeda",
          SelecionarBase: "Selecionar base",
          Observacao: "Observação",
        }
      }
    },

    SolicitacoesDePagamentoTransporteMissao: {
      deletar: "Tem certeza que gostaria de deletar essa solicitação?",

      titulo: "Solicitações de Pagamento - Transporte - Missão",

      botaoSolicitarPagamentoDeTransporteMissao: "Solicitar pagamento de transporte - Missão",

      tabela: {
        semSolicitacaoDePagamento: "Não há solicitação de pagamento cadastrada",
        ID: "ID",
        Status: "Status",
        Lote: "Lote",
        Frota: "Frota",
        Mes: "Mês",
        Base: "Base",
        Revisao: "Revisão",
        Quantidade: "Quantidade",
        Valor: "Valor",
        Moeda: "Moeda",
        Observaco: "Observação",
        Acoes: "Ações",
      }
    },

    AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento: {
      titulo: "Adicionar solicitação de pagamento - treinamento - deslocamento",

      formulario: {
        Treinamento: "Treinamento",
        Quantidade: "Quantidade",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Valor: "Valor",
        Moeda: "Moeda",
        ValorTotal: "Valor total",
        Observacao: "Observação",

        placeholder: {
          SelecionarTreinamento: "Selecionar treinamento",
          SelecionarMoeda: "Selecionar moeda",
          Observacao: "Observação",
        },

        tituloTrechos: "Trechos",

        botaoAdicionarTrecho: "Adicionar Trecho",

        tabela: {
          BuscarLocais: "Buscar Locais",
          BaseOrigem: "Base Origem",
          FornecedorOrigem: "Fornecedor Origem",
          CEPOrigem: "CEP Origem",
          BaseDestino: "Base Destino",
          FornecedorDestino: "Fornecedor Destino",
          CEPDestino: "CEP Destino",
        },

       botaoCalcular: "Calcular",
       botaoSalvarSolicitacao: "Salvar solicitação",
      }

    },

    SolicitacoesDePagamentoDeslocamentoTreinamento: {
      deletar: "Tem certeza que gostaria de deletar essa solicitação?",

      titulo: "Solicitações de Pagamento - Deslocamento - Treinamento",

      botaoSolicitarPagamentoDeDeslocamentoTreinamento: "Solicitar pagamento de deslocamento - Treinamento",

      tabela: {
        semSolicitacaoDePagamento: "Não há solicitação de pagamento cadastrada",
        ID: "ID",
        Status: "Status",
        Lote: "Lote",
        Treinamento: "Treinamento",
        Revisao: "Revisão",
        Inicio: "Início",
        Fim: "Fim",
        Quantidade: "Quantidade",
        Valor: "Valor",
        ValorTotal: "Valor Total",
        Moeda: "Moeda",
        Observacao: "Observação",
        Acoes: "Ações",
      },

      tituloBases: "Bases",

      tabelaBases: {
        Origem: "Origem",
        CEPOrigem: "CEP Origem",
        Destino: "Destino",
        CEPDestino: "CEP Destino",
      }

    },

    AdicionarSolicitacaoDePagamentoTreinamentoTransporte: {
      titulo: "Adicionar solicitação de pagamento - treinamento - transporte",

      formulario: {
        Treinamento: "Treinamento",
        Quantidade: "Quantidade",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Valor: "Valor",
        Moeda: "Moeda",
        ValorTotal: "Valor total",
        Base: "Base",
        Observacao: "Observação",

        botaoSalvarPagamento: "Salvar pagamento",

        placeholder: {
          SelecionarTreinamento: "Selecionar treinamento",
          SelecionarMoeda: "Selecionar moeda",
          SelecionarBase: "Selecionar base",
          Observacao: "Observação",
        }
      }
    },

    SolicitacoesDePagamentoTransporteTreinamento: {
      deletar: "Tem certeza que gostaria de deletar essa solicitação?",

      titulo: "Solicitações de Pagamento - Transporte - Treinamento",

      botaoSolicitarPagamentoDeTransporteTreinamento: "Solicitar pagamento de transporte - Treinamento",

      tabela: {
        semSolicitacaoDePagamento: "Não há solicitação de pagamento cadastrada",
        ID: "ID",
        Status: "Status",
        Lote: "Lote",
        Treinamento: "Treinamento",
        Base: "Base",
        Revisao: "Revisão",
        Quantidade: "Quantidade",
        Valor: "Valor",
        Moeda: "Moeda",
        Observacao: "Observação",
        Acoes: "Ações",
      }

    }
  },

  Escalas: {
    ListaDeEscalaDiaria: {
      botaoDisponivel: "Disponível",
      botaoIndisponivel: "Indisponível",

      deletar: "Tem certeza que gostaria de deletar essa escala?",

      titulo: "Lista de escala diária",

      botaoAdicionarProgramacao: "Adicionar programação",

      formulario: {
        botaoMudarData: "Mudar data",
      },

      tabela: {
        semProgramacaoParaHoje: "Não há programação cadastrada para hoje",
        ID: "ID",
        Base: "Base",
        Aeronave: "Aeronave",
        Modelo: "Modelo",
        Contrato: "Contrato",
        Disponibilidade: "Disponibilidade",
        ComandanteS: "Comandante(s)",
        CopilotoS: "Copiloto(s)",
        ComissarioS: "Comissário(s)",
        Apresentacao: "Apresentação",
        Corte: "Corte",
        Status: "Status",
        Acoes: "Ações"
      }
    },

    AdicionarEscalaDiaria: {
      titulo: "Cadastrar escala diária",

      formulario: {
        Data: "Data",
        Base: "Base",
        Prefixo: "Prefixo",
        Contrato: "Contrato",
        DesejaImportarTripulacaoDaEscala: "Deseja importar tripulação da escala",

        botaoSalvarProgramacao: "Salvar programação",
      }
    },

    EditarEscalaDiaria: {
      trocarOStatusDaEscala: "Tem certeza que gostaria de trocar o status da escala?",
      aprovarEscalaMesmoComAlertasVermelhos: "Tem certeza que gostaria de aprovar a escala mesmo com os alertas vermelhos?",

      titulo: "Editar escala diária",

      tituloEditarEscalaDiariaTripulacaoExtra: "Editar escala diária Tripulação Extra",

      botaoProgramacao: {
        TrocarParaRascunho: "Trocar para Rascunho",
        TrocarParaAprovada: "Trocar para Aprovada",
      },

      botaoAlertas: "Alertas",

      erros: "Os seguintes erros de preenchimento impediram a ficha de indisponibilidade de ser processada",

      tituloDisponibilidadeDaAeronave: "Disponibilidade da Aeronave",

      formularioDisponibilidadeDaAeronave: {
        Disponivel: "Disponível",
        IndisponivelDesde: "Indisponível desde",
        Razao: "Razão",
        Previsao: "Previsão",
        FlightFollowingAnormal: "Flight following anormal",
        AnormalDesde: "Anormal desde",
        InspetorMecanicoResponsavel: "Inspetor / Mecânico Responsável",
        Observacoes: "Observações",
      },

      tituloCriarGrupo: "Criar grupo",

      formularioCriarGrupo: {
        HorarioDeApresentacao: "Horário de Apresentação",
        HorarioDeTerminoDaJornada: "Horário de Término da Jornada",
        Situacao: "Situação",
        Voos: "Vôos",
        
        botaoAdicionarGrupo: "Adicionar grupo",
      },

      tituloAlertasDeAprovacao: "Alertas de aprovação",

      tabelaAlertasDeAprovacao: {
        Mensagem: "Mensagem",
        Data: "Data",
      },

      tituloLogDeStatus: "Log de status",

      tabelaLogDeStatus: {
        Usuario: "Usuário",
        Acao: "Ação",
        Descricao: "Descrição",
        Justificativa: "Justificativa",
        Data: "Data",
      },

      tituloAlertas: "Alertas",

      formularioAlertas: {
        Justificativa: "Justificativa",

        botaoContinuarAprovacao: "Continuar aprovação",
      },

      //ScheduleGroupStaff abaixo
      deletarTripulante: "Tem certeza que deseja deletar esse tripulante?",
      deletarGrupo: "Tem certeza que deseja deletar esse grupo?",

      tituloGrupoAs(Numero, Inicio, Fim) {
        // Verifico se o Fim é nulo, se for, retorno apenas o Inicio
        if (Fim == null) {
          return `Grupo ${Numero} - ${Inicio}`
        }
        return `Grupo ${Numero} - ${Inicio} às ${Fim}`
      },
      
      formularioGrupo: {
        HorarioDeApresentacao: "Horário de Apresentação",
        HorarioDeTerminoDaJornada: "Horário de Término da Jornada",
        Situacao: "Situação",
        
        botaoEditarGrupo: "Editar grupo",
      },

      formularioAdicionarComandante: {
        Comandante: "Comandante",
      },

      formularioAdicionarCopiloto: {
        Copiloto: "Copiloto",
      },

      formularioAdicionarComissario: {
        Comissario: "Comissário",
      },

      tabelaGrupo: {
        Tripulante: "Tripulante",
        Funcao: "Função",
      }

    },

    ListaDeEscalas: {
      botaoRevisao: "Revisão",

      titulo: "Lista de escalas",
      botaoAdicionarEscala: "Adicionar escala",

      tabela: {
        semEscalasEsteMes: "Não há escalas cadastradas para este mês",
        ID: "ID",
        Frota: "Frota",
        Base: "Base",
        Referencia: "Referência",
        Acoes: "Ações",
      }
    },
  },

  Configuracoes: {

    EditarConfiguracoes: {
      deletarConfiguracao: "Tem certeza que gostaria de deletar essa configuração?",
      deletarTarefa: "Tem certeza que gostaria de deletar essa tarefa?",

      titulo: "Edição de configurações de fadiga",

      formulario: {
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        LimiteDePontosZonaVerde: "Limite de pontos - zona verde",
        LimiteDePontosZonaAmarela: "Limite de pontos - zona amarela",
        LimiteDePontosZonaVermelha: "Limite de pontos - zona vermelha",
        LimiteDePontosDiario: "Limite de pontos - diário",
        PontuacaoPorDiaDeFolga: "Pontuação por dia de folga",
        PontuacaoDiariaMediaParaSimulacao: "Pontuação Diária Média para Simulação",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
        }
      },

      tituloConfiguracoesDePontuacao: "Configurações de Pontuação",

      tabelaConfiguracoesDePontuacao: {
        TipoDeColaborador: "Tipo de Colaborador",
        Acoes: "Ações",
      },

      tituloEditarConfiguracao: "Editar configuração",

      formularioEditarConfiguracao: {
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        LimiteDePontosZonaVerde: "Limite de pontos - zona verde",
        LimiteDePontosZonaAmarela: "Limite de pontos - zona amarela",
        LimiteDePontosZonaVermelha: "Limite de pontos - zona vermelha",
        LimiteDePontosDiario: "Limite de pontos - diário",
        PontuacaoPorDiaDeFolga: "Pontuação por dia de folga",
        PontuacaoDiariaMediaParaSimulacao: "Pontuação Diária Média para Simulação",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
        }
      },

      tituloTarefasDeRestricao: "Tarefas de restrição",

      formularioTarefasDeRestricao: {
        Tarefa: "Tarefa",
        LimiteDaRestricao: "Limite da restrição",
        Restricao: "Restrição",

        botaoCadastrarTarefa: "Cadastrar tarefa",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarLimite: "Selecionar limite",
          Restricao: "Restrição",
        }
      },

      tituloTarefasDaAplicabilidade: "Tarefas da aplicabilidade",

      tabelaTarefasDaAplicabilidade: {
        Limite: "Limite",
        Tarefa: "Tarefa",
        Restricao: "Restrição",
        Acoes: "Ações",
      },
    }
  },

  ColaboradoresSigmec: {
    ComunicadosDeTreinamentos: {
      botaoComunicado: "Comunicado",

      titulo: "Comunicados de Treinamentos",

      tabela: {
        semTreinamentos: "Não há treinamentos cadastrados",
        ID: "ID",
        Nome: "Nome",
        Status: "Status",
        CodigoDeControle: "Código de controle",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Acoes: "Ações",
      },
    },

    ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia: {
      botaoConfirmarPresenca: "Confirmar presença",
      botaoConfirmarAusencia: "Confirmar ausência",

      titulo: "Comunicados de treinamentos pendentes de confirmação de presença/ausência",

      tabela: {
        semTreinamentos: "Não há treinamentos cadastrados",
        ID: "ID",
        Nome: "Nome",
        Status: "Status",
        CodigoDeControle: "Código de controle",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Acoes: "Ações",
      }
    },

    EdicaoDeColaborador: {
      trocarStatusDoColaborador: "Tem certeza que deseja trocar o status do colaborador?",

      titulo: "Edição de colaborador",

      tabDadosDoColaborador: {
        tituloTab: "Dados do colaborador",

        formulario: {
          tituloInformacoesPessoais: "Informações pessoais",
          
          Nome: "Nome",
          Email: "E-mail",
          EstadoCivil: "Estado civil",
          TipoSanguineo: "Tipo sanguíneo",
          Telefone1: "Telefone 1",
          Telefone2: "Telefone 2",
          DadosBancarios: "Dados bancários",
          Nascimento: "Nascimento",
          PaisNascimento: "País nascimento",
          UFNascimento: "UF nascimento",
          CidadeNascimento: "Cidade nascimento",
          Endereco: "Endereço",
          Numero: "Número",
          Complemento: "Complemento",
          Bairro: "Bairro",
          Cidade: "Cidade",
          UF: "UF",
          Pais: "País",
          PIS: "PIS",
          CEP: "CEP",
          CPF: "CPF",
          Identidade: "Identidade",
          IDUF: "ID UF",
          OrgaoDeExpedicao: "Orgão de Expedição",
          IDExpedicao: "ID Expedição",
          CarteiraDeTrabalhoUF: "Carteira de Trabalho UF",
          CarteiraDeTrabalhoProfissional: "Carteira de Trabalho Profissional",
          CarteiraDeTrabalhoExpedicao: "Carteira de Trabalho Expedição",
          EscolaFormacao: "Escola/Formação",
          Escolaridade: "Escolaridade",
          ConfidenceUS: "Confidence US",
          ExpiracaoConfidenceUS: "Expiração confidence US",
          ConfidenceEU: "Confidence EU",
          ExpiracaoConfidenceEU: "Expiração confidence EU",
          Passaporte: "Passaporte",
          PassaporteExpiracao: "Passaporte Expiração",
          TituloDeEleitor: "Título de Eleitor",
          ZonaDeEleitor: "Zona de Eleitor",
          SessaoDeEleitor: "Sessão de Eleitor",
          CNHCategoria: "CNH categoria",
          CNH: "CNH",
          CNHExpiracao: "CNH expiração",
          Reservista: "Reservista",
          ReservistaCategoria: "Reservista categoria",
          CertificadoMilitar: "Certificado Militar",
          CertificadoMilitarMinisterio: "Certificado Militar Ministério",
          CertificadoMilitarObservacoes: "Certificado militar observações",
          VistoAmericano: "Visto Americano",
          CREA: "CREA",
          CREATitulo: "CREA título",
          CREAExpedicao: "CREA expedição",
          CREAValidade: "CREA validade",
          ASO: "ASO",
          Contratacao: "Contratação",
          Demissao: "Demissão",
          NomeDaMae: "Nome da mãe",
          NomeDoPai: "Nome do pai",

          tituloInformacoesProfissionais: "Informações Profissionais",

          Licenca: "Licença",
          CANAC: "CANAC",
          Matricula: "Matrícula",
          ValorHora: "Valor hora",
          ContratoSISPAT: "Contrato SISPAT",
          CodigoSapiens: "Código Sapiens",

          placeholder: {
            NomeDoColaborador: "Nome do colaborador",
            EmailDoColaborador: "E-mail do colaborador",
            EstadoCivil: "Estado civil",
            TipoSanguineo: "Tipo sanguíneo",
            TelefoneDoColaborador: "Telefone do colaborador",
            DadosBancarios: "Dados Bancários",
            NascimentoDoColaborador: "Nascimento do colaborador",
            PaisNascimento: "País nascimento",
            SelecioneOUF: "Selecione o UF",
            CidadeNascimento: "Cidade nascimento",
            EnderecoDoColaborador: "Endereço do colaborador",
            Numero: "Número",
            Complemento: "Complemento",
            BairroDoColaborador: "Bairro do colaborador",
            CidadeDoColaborador: "Cidade do colaborador",
            Pais: "País",
            PIS: "PIS",
            CEPDoColaborador: "CEP do colaborador",
            CPFDoColaborador: "CPF do colaborador",
            EstadoDeEmissaoDaID: "Estado de emissão da ID",
            OrgaoExpeditorDaID: "Orgão expeditor da ID",
            ExpedicaoDaID: "Expedição da ID",
            CarteiraDeTrabalhoUF: "Carteira de Trabalho UF",
            CarteiraDeTrabalhoProfissional: "Carteira de Trabalho Profissional",
            CarteiraDeTrabalhoExpedicao: "Carteira de Trabalho Expedição",
            EscolaFormacao: "Escola/Formação",
            Escolaridade: "Escolaridade",
            NumeroDoCartaoConfidenceAmericano: "Nº do cartão confidence americano",
            ValidadeDoCartaoConfidenceAmericano: "Validade do cartão confidence americano",
            NumeroDoCartaoConfidenceEuropeu: "Nº do cartão confidence europeu",
            ValidadeDoCartaoConfidenceEuropeu: "Validade do cartão confidence europeu",
            NumeroDoPassaporte: "Nº do passaporte",
            ExpiracaoDoPassaporte: "Expiração do passaporte",
            TituloDeEleitor: "Título de Eleitor",
            ZonaDeEleitor: "Zona de Eleitor",
            SessaoDeEleitor: "Sessão de Eleitor",
            CNHCategoria: "CNH categoria",
            NumeroDaCarteiraDeMotorista: "Nº da carteira de motorista",
            ExpiracaoDaCarteiraDeMotorista: "Expiração da carteira de motorista",
            Reservista: "Reservista",
            ReservistaCategoria: "Reservista categoria",
            CertificadoMilitar: "Certificado Militar",
            CertificadoMilitarMinisterio: "Certificado Militar Ministério",
            CertificadoMilitarObservacoes: "Certificado militar observações",
            VistoAmericano: "Visto Americano",
            CREA: "CREA",
            CREATitulo: "CREA título",
            CREAExpedicao: "CREA expedição",
            CREAValidade: "CREA validade",
            ASO: "ASO",
            Contratacao: "Contratação",
            Demissao: "Demissão",
            NomeDaMaeDoColaborador: "Nome da mãe do colaborador",
            NomeDoPaiDoColaborador: "Nome do pai do colaborador",
            Licenca: "Licença",
            CANAC: "CANAC",
            InscricaoDoColaborador: "Inscrição do colaborador",
            ValorHora: "Valor hora",
            ContratoSISPAT: "Contrato SISPAT",
            CodigoSapiens: "Código Sapiens",
          }
        }

      },

      tabHabilitacoes: {
        tituloTab: "Habilitações",

        opcoesNome: {
          AVI: "AVI",
          CEL: "CEL",
          GMP: "GMP",
        },

        opcoesTipo: {
          SelecionarTipo: "Selecionar tipo",
          CHT: "CHT",
          CCT: "CCT",
        },

        tituloHabilitacoes: "Habilitações",

        nenhumaHabilitacaoCadastrada: "Nenhuma habilitação cadastrada.",

        tabela: {
          Tipo: "Tipo",
          Nome: "Nome",
          Expedicao: "Expedição",
          Vencimento: "Vencimento",
          Valido: "Válido",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }

      },

      tabTarefasDesignadas: {
        tituloTab: "Tarefas designadas",

        tituloTarefas: "Tarefas",

        nenhumaTarefaCadastrada: "Nenhuma tarefa cadastrada.",

        tabela: {
          Tarefa: "Tarefa",
          Vencimento: "Vencimento",
          Valido: "Válido",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }

      },

      tabFrotasDesignadas: {
        tituloTab: "Frotas designadas",

        tituloFrotasDesignadas: "Frotas designadas",

        nenhumaFrotaCadastrada: "Nenhuma frota cadastrada.",

        tabela: {
          Aeronave: "Aeronave",
          Subtipo: "Subtipo",
          Vencimento: "Vencimento",
          Instrucao: "Instrução",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }

      },

      tabFrotasObrigatorias: {
        tituloTab: "Frotas obrigatórias",

        tituloFrotasObrigatorias: "Frotas obrigatórias",

        nenhumaFrotaCadastrada: "Nenhuma frota cadastrada.",

        tabela: {
          Aeronave: "Aeronave",
          Subtipo: "Subtipo",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }

      },

      tabDesignacoes: {
        tituloTab: "Designações",

        tituloDesignacoes: "Designações",

        tabRevisoesDeDesignacoes: {
          tituloTab: "Revisões de Designações",

          botaoExportacoes: {
            ExportarDesignacoes: "Exportar designações",
            Revisao: "Revisão",
            
            RevisaoArquivo(Numero, Status){
              return `Revisão ${Numero} - ${Status} - Arquivo`
            },

            RevisaoObservacoes(Numero, Status){
              return `Revisão ${Numero} - ${Status} - Observações`
            }
          },

          nenhumaDesignacaoCadastrada: "Nenhuma designação cadastrada.",

          tituloRevisao: "Revisão",

          tabela: {
            Codigo: "Código",
            Designacao: "Designação",
            DS: "DS",
            CEL: "CEL",
            GMP: "GMP",
            AVI: "AVI",
            ProdutoEspecificacao: "Produto/Especificação",
            LimitacoesObservacoes: "Limitações/Observações",

            Acfts: "Acfts.",
            Eng: "Eng.",
            Comp: "Comp.",
          },

          designacoesComProdutoEspecificacaoEscritosManualmente: "Designações com produto/especificação escritos manualmente",

          tituloRazaoDeAberturaDaRevisao: "Razão de abertura da revisão",
          tituloRazaoNaoDisponivel: "Razão não disponível",

          tituloHabilitacoesDesignadasDestaRevisao: "Habilitações designadas desta revisão",

          nenhumaHabilitacaoCadastrada: "Nenhuma habilitação cadastrada.",

          tabelaHabilitacoesDesignadasDestaRevisao: {
            Nome: "Nome",
            Expiração: "Expiração",
          },

          tituloTarefasDesignadasDestaRevisao: "Tarefas designadas desta revisão",

          nenhumaTarefaCadastrada: "Nenhuma tarefa cadastrada.",

          tabelaTarefasDesignadasDestaRevisao: {
            Nome: "Nome",
            Expiracao: "Expiração",
          },

          tituloFrotasDesignadasDestaRevisao: "Frotas designadas desta revisão",

          nenhumaFrotaCadastrada: "Nenhuma frota cadastrada.",

          tabelaFrotasDesignadasDestaRevisao: {
            Nome: "Nome",
            Expiracao: "Expiração",
          },

          tituloLogDeAcoesManuaisDestaRevisao: "Log de ações manuais desta revisão",

          nenhumaAcaoCadastrada: "Nenhuma ação cadastrada.",

          tabelaLogDeAcoesManuaisDestaRevisao: {
            Acao: "Ação",
            Tipo: "Tipo",
            Usuario: "Usuário",
            Data: "Data",
          },

          osColaboradorNaoPossuiOsCertificadosListadosAbaixo: "Os colaborador não possui os certificados listados abaixo, necessários para este item de designação",

        }

      },

      tabExperienciaProfissional: {
        tituloTab: "Experiência profissional",

        titutloExperienciaProfissional: "Experiência profissional",

        nenhumaExperienciaProfissionalCadastrada: "Nenhuma experiência profissional cadastrada.",
        
        tabela: {
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          Empresa: "Empresa",
          Funcao: "Função",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }

      },

      tabProvasDeIdioma: {
        tituloTab: "Provas de idioma",

        tituloListaDeProvasDeIdioma: "Lista de Provas de Idioma",

        nenhumaProvasDeIdiomaCadastrada: "Nenhuma provas de idioma cadastrada.",

        tabela: {
          Coeficiente: "Coeficiente",
          Idioma: "Idioma",
          Emissao: "Emissão",
          Vencimento: "Vencimento",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }
      },

      tabFerias: {
        tituloTab: "Férias",

        tituloFerias: "Férias",

        nenhumaFeriasCadastrada: "Nenhuma férias cadastrada.",

        tabela: {
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          DireitoAFerias: "Direito à férias",
          VencimentoDeFerias: "Vencimento de férias",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }
      },

      tabFuncoes: {
        tituloTab: "Funções",

        tituloFuncoes: "Funções",

        nenhumaFuncaoCadastrada: "Nenhuma função cadastrada.",

        tabela: {
          DataInicial: "Data Inicial",
          Funcao: "Função",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }

      },

      tabBases: {
        tituloTab: "Bases",

        tituloBases: "Bases",

        nenhumaBaseCadastrada: "Nenhuma base cadastrada.",

        tabela: {
          DataInicial: "Data Inicial",
          Base: "Base",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }

      },

      tabNiveisDeCargos: {
        tituloTab: "Níveis de cargos",

        tituloNiveisDeCargos: "Níveis de cargos",

        nenhumaAeronaveCadastrada: "Nenhuma aeronave cadastrada.",

        tabela: {
          DataDeAlteracao: "Data de alteração",
          Nivel: "Nível",
          Motivo: "Motivo",
        }

      },

      tabCargos: {
        tituloTab: "Cargos",

        tituloCargos: "Cargos",

        nenhumCargoCadastrado: "Nenhum cargo cadastrado.",

        tabela: {
          DataInicial: "Data Inicial",
          Cargo: "Cargo",
          CodRubi: "Cód. Rubi",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }

      },
      
      tabCarimbos: {
        tituloTab: "Carimbos",

        opcoesCarimbo: {
          Circulo: "Círculo",
          Triangulo: "Triângulo",
          Quadrado: "Quadrado",
          Pentagono: "Pentágono",
          Hexagono: "Hexágono",
        },

        tituloCarimbos: "Carimbos",

        nenhumCarimboCadastrado: "Nenhum carimbo cadastrado.",

        tabela: {
          DataDeEmissao: "Data de emissão",
          Funcao: "Função",
          TipoDeCarimbo: "Tipo de carimbo",
          Numero: "Número",
          Revisao: "Revisão",
          Observacao: "Observação",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }

      },
      
      tabTreinamentos: {
        tituloTab: "Treinamentos",

        tituloCertificados: "Certificados",

        nenhumCertificadoCadastrado: "Nenhum certificado cadastrado",

        tabela: {
          ID: "ID",
          Tipo: "Tipo",
          Fim: "Fim",
          Vencimento: "Vencimento",
          Val: "Val.",
          Status: "Status",
          Ações: "Ações",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }

      },
      
      tabNecessidadeDeTreinamentos: {
        tituloTab: "Necessidade de treinamentos",

        tituloAvaliacaoDeNecessidadeDeTreinamento: "Avaliação de necessidade de treinamento",

        naoHaFormulariosDeAvaliacao: "Não há formulários de avaliação de necessidade de treinamento para este funcionário.",

        tabela: {
          Data: "Data",
          MotivoDaAnalise: "Motivo da análise",
          OutrasAtividades: "Outras Atividades",
          Acoes: "Ações",
        },

        tituloAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo: "Avaliação de necessidade de treinamento - MODELO ANTIGO",

        tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo:{
          Conhecimento: "Conhecimento",
          OutrasAtividades: "Outras Atividades",
          Data: "Data",
          Acoes: "Ações",
          
          ConhecimentoETreinamento: "Conhecimento e Treinamento",
          Experiencia: "Experiência",
          Oficina: "Oficina",
          Aeronaves: "Aeronaves",
          Motores: "Motores",
          Inspecao: "Inspeção",
          Instrucao: "Instrução",
          Criacao: "Criação",
        },

        deletarItem: "Tem certeza que gostaria de deletar esse item?",

        tituloEditarNecessidadeDeTreinamento: "Editar necessidade de treinamento",

        formularioEditarNecessidadeDeTreinamento: {
          Data: "Data",
          MotivoDaAnalise: "Motivo da análise",

          opcoesMotivoDaAnalise: {
            ContratacaoDoColaborador: "Contratação do Colaborador",
            NovaFuncaoDoColaborador: "Nova Função do Colaborador",
            PromocaoDoColaborador: "Promoção do Colaborador",
            Outro: "Outro",
          },

          PreenchaOMotivo: "Preencha o motivo",

          OutrasAtividades: "Outras atividades",

          tituloProcedimentosInternos: "Procedimentos internos",

          Integracao: "Integração",
          Geral: "Geral",
          SUP: "SUP",
          FER: "FER",
          MNT: "MNT",
          ENG: "ENG",
          CTM: "CTM",
          SASC: "SASC",
          QUA: "QUA",
          Inspetores: "Inspetores",
          Rampa: "Rampa",

          tituloApoio: "Apoio",

          Corrosao: "Corrosão",
          PBN: "PBN",
          HUMSNivel1: "HUMS Nível 1",
          HUMSNivel2: "HUMS Nível 2",
          Ingles: "Inglês",
          Boroscopia: "Boroscopia",
          FatoresHumanos: "Fatores Humanos",
          Orientacao: "Orientação",
          Pedagogica: "Pedagógica",
          ArtigosPerigosos: "Artigos Perigosos",
          EOS: "EOS",
        },

        tituloTreinamentosDeProdutos: "Treinamentos de produtos",

        tabelaTreinamentosDeProdutos: {
          Aeronaves: "Aeronaves",
          Motores: "Motores",
          Oficinas: "Oficinas",
        },

        tituloConhecimentoTreinamentoEExperienciaAnterior: "Conhecimento, Treinamento e Experiência Anterior",

        tabelaConhecimentoTreinamentoEExperienciaAnterior: {
          Descricao: "Descrição",
          Organizacao: "Organização",
          Periodo: "Período",
        }

      },

      tabColaboradorReferencia: {
        tituloTab: "Colaborador referência",

        tituloReferencias: "Referências",

        nenhumaReferenciaCadastrada: "Nenhuma referência cadastrada.",

        tabela: {
          Aeronave: "Aeronave",
          Referencia: "Referência",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }

      },

      tabAfastamentos: {
        tituloTab: "Afastamentos",

        tituloAfastamento: "Afastamento",

        nenhumaAfastamentoCadastrada: "Nenhuma afastamento cadastrada.",

        tabela: {
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          Motivo: "Motivo",
        }

      },

      tabRegimeDeTrabalho: {
        tituloTab: "Regime de trabalho",

        tituloRegimeDeTrabalho: "Regime de Trabalho",

        nenhumRegimeCadastrado: "Nenhum regime cadastrado.",

        tabela: {
          Tipo: "Tipo",
          DataInicial: "Data inicial",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }

      },

      tabFormacaoAcademica: {
        tituloTab: "Formação acadêmica",

        opcoesTipoDeFormacao: {
          SelecionarTipo: "Selecionar tipo",
          PrimeiroGrau: "1º Grau",
          SegundoGrau: "2º Grau",
          EnsinoSuperior: "Ensino superior",
          PosGraduacao: "Pós graduação",
          MMA: "MMA",
        },

        tituloFormacaoAcademica: "Formação acadêmica",

        nenhumaFormacaoCadastrada: "Nenhuma formação cadastrada.",

        tabela: {
          Tipo: "Tipo",
          NomeDoCurso: "Nome do curso",
          Instituicao: "Instituição",
          DataDeConclusao: "Data de conclusão",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        }

      },

      tabBaseContratual: {
        tituloTab: "Base Contratual",

        tituloBases: "Bases",

        nenhumaBaseCadastrada: "Nenhuma base cadastrada.",

        tabela: {
          Base: "Base",

        }

      },
    },
  },

  ColaboradoresSigtrip: {
    ComunicadosDeTreinamentos: {
      botaoExportar: {
        Exportar: "Exportar",
        Solo: "Solo",
        SoloTIC: "Solo TIC",
        Simulador: "Simulador",
        EAD: "EAD",
      },

      titulo: "Comunicados de Treinamentos",

      tabela: {
        semTreinamentos: "Não há treinamentos cadastrados",
        ID: "ID",
        Nome: "Nome",
        Status: "Status",
        CodigoDeControle: "Código de controle",
        TiposDeCertificado: "Tipos de certificado",
        Modalidade: "Modalidade",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Acoes: "Ações",
      }

    },

    DocumentosPendentesDeConhecimento: {
      deletarPapeleta: "Tem certeza que gostaria de deletar essa papeleta?",

      titulo: "Documentos pendentes de conhecimento",

      tituloAListaDeDocumentosPendentesEOriundaDoQPulse: "A lista de documentos pendentes é oriunda do Q-Pulse e é atualizada uma vez ao dia, às 05:00",

      tabela: {
        semDocumentosPendentes: "Não há documentos pendentes de conhecimento",
        ID: "ID",
        Matricula: "Matrícula",
        Nome: "Nome",
        Documentos: "Documentos",
      }

    },
    
    ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia: {
      botaoConfirmarPresenca: "Confirmar presença",
      botaoConfirmarAusencia: "Confirmar ausência",

      titulo: "Comunicados de treinamentos pendentes de confirmação de presença/ausência",

      tabela: {
        semTreinamentos: "Não há treinamentos pendentes de confirmação",
        ID: "ID",
        Nome: "Nome",
        Status: "Status",
        CodigoDeControle: "Código de controle",
        TiposDeCertificado: "Tipos de certificado",
        Modalidade: "Modalidade",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        Acoes: "Ações",
      }
    },

    EscalasPendentesDeConhecimento: {
      botaoRevisao: "Revisão",

      titulo: "Escalas pendentes de conhecimento",

      tabela: {
        semEscalas: "Não há escalas pendentes de conhecimento",
        ID: "ID",
        Mes: "Mês",
        Base: "Base",
        Frota: "Frota",
        Revisao: "Revisão",
        Status: "Status",
        Acoes: "Ações",
      }
    },

    PapeletasPendentesDeAprovacao: {
      titulo: "Papeletas pendentes de aprovação",

      tabela: {
        semPapeletas: "Não há papeletas pendentes de aprovação",
        ID: "ID",
        Nome: "Nome",
        Matricula: "Matrícula",
        Referencia: "Referência",
        Status: "Status",
        Acoes: "Ações",
      }
    },

    RelatoriosPendentesDeAprovacao: {
      titulo: "Relatórios pendentes de aprovação",

      tabela: {
        semRelatorios: "Não há relatórios pendentes de aprovação",
        ID: "ID",
        Base: "Base",
        Data: "Data",
        Aeronave: "Aeronave",
        Frota: "Frota",
        Cliente: "Cliente",
        TipoDeVoo: "Tipo de voo",
        NumeroDoRelatorio: "Número do relatório",
        NumeroDoVoo: "Número do voo",
        Status: "Status",
        Acoes: "Ações",
      }

    },

    EditarFuncionario: {
      titulo: "Edição de funcionário",

      tabDadosDoFuncionario: {
        tituloTab: "Dados do funcionário",

        formulario: {
          tituloInformacoesPessoais: "Informações pessoais",
  
          Nome: "Nome",
          Apelido: "Apelido",
          Telefone1: "Telefone 1",
          Telefone2: "Telefone 2",
          EstadoCivil: "Estado civil",
          Email: "E-mail",
          Naturalidade: "Naturalidade",
          Escolaridade: "Escolaridade",
          NomeDaMae: "Nome da mãe",
          NomeDoPai: "Nome do pai",
          Raca: "Raça",
          DataDeNascimento: "Data de nascimento",
  
          tituloEndereco: "Endereço",
  
          Endereco: "Endereço",
          Numero: "Número",
          Complemento: "Complemento",
          Bairro: "Bairro",
          Cidade: "Cidade",
          Estado: "Estado",
          Pais: "País",
          CEP: "CEP",
          CPF: "CPF",
          Identidade: "Identidade",
          IdentidadeUF: "Identidade - UF",
          IdentidadeDataDeExpedicao: "Identidade - data de expedição",
          IdentidadeOrgaoExpeditor: "Identidade - orgão expeditor",
          PIS: "PIS",
          ConfidenceUS: "Confidence US",
          ExpiracaoConfidenceUS: "Expiração confidence US",
          ConfidenceEU: "Confidence EU",
          ExpiracaoConfidenceEU: "Expiração confidence EU",
          CTPS: "CTPS",
          CTPSNumeroDeSerie: "CTPS - N de Serie",
          CTPSExpedicao: "CTPS expedição",
          CTPSUF: "CTPS UF",
          TipoSanguineo: "Tipo sanguíneo",
          Matricula: "Matrícula",
          SISPAT: "SISPAT",
          CANAC: "CANAC",
          Licenca: "Licença",
          Contratacao: "Contratação",
          CargoDeAdmissao: "Cargo de admissão",
          CargoAtual: "Cargo Atual",
          EstadoDeNascimento: "Estado de nascimento",
          CidadeDeNascimento: "Cidade de nascimento",
          PaisDeNascimento: "País de nascimento",
          ASO: "ASO",
          Eletrocardiograma: "Eletrocardiograma",
          CodigoSapiens: "Código Sapiens",
        }        

      },

      tabAdministrativo: {
        tituloTab: "Administrativo",
        
        tituloAdicionarArquivos: "Adicionar arquivos",

        tabela: {
          semArquivos: "Não há arquivos cadastrados",
          NomeDoArquivo: "Nome do arquivo",
          Tipo: "Tipo",
          Validade: "Validade",
        }

      },

      tabHorasDeVoo: {
        tituloTab: "Horas de voo",

        tituloTotaisDeHoras: "Totais de horas",

        tabelaTotaisDeHoras: {
          semAeronaves: "Não há aeronaves cadastrados",
          ID: "ID",
          Modelo: "Modelo",
          FB: "FB",
          Total: "Total",
          IFR: "IFR.",
          Noturno: "Noturno",
          APP: "APP",
          Diurno: "Diurno",
        },

        tabelaArquivos: {
          semArquivos: "Não há arquivos cadastrados",
          NomeDoArquivo: "Nome do arquivo",
          Validade: "Validade",
        }
      },

      tabHabilitacoes: {
        tituloTab: "Habilitações",

        opcoesCodigoDeHabilitacao: {
          CCF: "CCF",
          CHT: "CHT",
        },

        opcoesHabilitacao: {
          SelecionarTipo: "Selecionar tipo",
          IFRH: "IFRH",
        },

        tituloHabilitacoes: "Habilitações",

        botaoEsconderArquivoMorto: "Esconder arquivo morto",
        botaoMostrarArquivoMorto: "Mostrar arquivo morto",

        nenhumaHabilitacaoCadastrada: "Nenhuma habilitação cadastrada.",

        tabela: {
          Codigo: "Código",
          Frota: "Frota",
          Tipo: "Tipo",
          CANAC: "CANAC",
          Licenca: "Licença",
          Vencimento: "Vencimento",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },
      },

      tabProcessos: {
        tituloTab: "Processos",

        tituloProcessos: "Processos",

        tabela: {
          semArquivosDeProcessos: "Não há arquivos de processos",
          Frota:"Frota",
          Processo: "Processo",
          Subtipo: "Subtipo",
          DataDeEmissao: "Data de emissão",
          Validade: "Validade",
        }

      },

      tabCertificacoes: {
        tituloTab: "Certificações",

        tituloCertificados: "Certificados",

        nenhumCertificadoCadastrado: "Nenhum certificado cadastrado.",

        tabela: {
          NomeDoCertificado: "Nome do certificado",
          Inicio: "Início",
          Fim: "Fim",
          Vencimento: "Vencimento",
          Status: "Status",
          Arquivo: "Arquivo",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },
      },

      tabAvaliacoes: {
        tituloTab: "Avaliações",

        tituloAvaliacoes: "Avaliações",

        nenhumCertificadoCadastrado: "Nenhum certificado cadastrado.",

        tabela: {
          NomeDoCertificado: "Nome do certificado",
          Inicio: "Início",
          Fim: "Fim",
          Vencimento: "Vencimento",
          Status: "Status",
          Arquivo: "Arquivo",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },
      },

      tabCargos: {
        tituloTab: "Cargos",

        tituloCargos: "Cargos",

        nenhumCargoCadastrado: "Nenhum cargo cadastrado.",

        tabela: {
          Cargo: "Cargo",
          CodigoRubi: "Cód. Rubi",
          Status: "Status",
          Data: "Data",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },
      },

      tabDesignacoes: {
        tituloTab: "Designações",

        tituloDesignacoes: "Designações",

        nenhumaDesignacaoCadastrada: "Nenhuma designação cadastrada.",

        tabela: {
          Designacao: "Designação",
          Frota: "Frota",
          Status: "Status",
          Data: "Data",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },
      },

      tabIndicacoes: {
        tituloTab: "Indicações",

        tituloIndicacao: "Indicação",

        nenhumaIndicacaoCadastrada: "Nenhuma indicação cadastrada.",
        
        tabela: {
          Designacao: "Designação",
          Frota: "Frota",
          Status: "Status",
          Data: "Data",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },
      },

      tabRegimes: {
        tituloTab: "Regimes",

        tituloRegimes: "Regimes",

        nenhumRegimeCadastrado: "Nenhum regime cadastrado.",

        tabela: {
          Regime: "Regime",
          Data: "Data",
          Mes: "Mês",
          Ano: "Ano",
          Status: "Status",
          
          Ativo: "ativo",
          Arquivado: "arquivado",
        },
      },

      tabGratificacoes: {
        tituloTab: "Gratificações",

        tituloGratificacoes: "Gratificações",

        nenhumaGratificacaoCadastrada: "Nenhuma gratificação cadastrada.",

        tabela: {
          Gratificacao: "Gratificação",
          Data: "Data",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },
      },

      tabAprovacoes: {
        tituloTab: "Aprovações",

        tituloAprovacoesDeClientes: "Aprovações de clientes",

        nenhumaAprovacaoCadastrada: "Nenhuma aprovação cadastrada.",

        tabela: {
          Client: "Client",
          Grupo: "Grupo",
          Funcao: "Função",
          Aeronaves: "Aeronaves",
        }

      },

      tabICAO: {
        tituloTab: "ICAO",

        tituloICAOS: "ICAOS",

        nenhumICAOCadastrado: "Nenhum ICAO cadastrado.",

        tabela: {
          Level: "Level",
          Vencimento: "Vencimento",
          DataDeInsercao: "Data de Inserção",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },
      },

      tabBaseContratual: {
        tituloTab: "Base contratual",

        tituloBases: "Bases",

        nenhumaBaseCadastrada: "Nenhuma base cadastrada.",

        tabela: {
          Base: "Base",
          Status: "Status",

          Ativo: "ativo",
          Arquivado: "arquivado",
        },
      },
    },

  },
  
  Papeletas: {
    ListaDePapeletas: {
      deletar: "Tem certeza que gostaria de deletar essa papeleta?",

      botaoAprovarSelecionados: "Aprovar selecionados",

      titulo: "Lista de papeletas",

      tabela: {
        semPapeletasPendentes: "Não há papeletas pendentes",
        ID: "ID",
        Nome: "Nome",
        Matricula: "Matrícula",
        Referencia: "Referência",
        Status: "Status",
        Acoes: "Ações",
      }
    },

    AdicionarPapeleta: {
      titulo: "Cadastrar papeleta",

      formulario: {
        MesAno: "Mês/ano",

        Tripulante: "Tripulante",
      }
    },

    EditarPapeleta: {
      aguardeEnquantoOArquivoEGerado: "Aguarde enquanto o arquivo é gerado. Este processo pode levar alguns minutos.",
      atualizarAsInformacoes: "Tem certeza que deseja atualizar as informações? As alterações realizadas na FIRA serão perdidas.",

      titulo: "Edição de papeleta",

      botaoAtualizar: "Atualizar",
      botaoAlertas: "Alertas",

      tituloPendencias: "Pendências",

      tabelaPendencias: {
        Data: "Data",
        Localidades: "Localidades",
        Situacao: "Situação",
        Horarios: "Horários",
        Totais: "Totais",
        Apresentacao: "Apresentação",
        Liberacao: "Liberação",
        InicioDaRefeicao: "Início da Refeição",
        TerminoDaRefeicao: "Término da Refeição",
        InicioDaSegundaRefeicao: "Início da Segunda Refeição",
        TerminoDaSegundaRefeicao: "Término da Segunda Refeição",
        HorasDeJornada: "Horas de Jornada",
        VooNoturno: "Voo Noturno",
        VooTotal: "Voo Total",   

        ///pendencyday
        AtualizarAsInformacoesDestaDataDeAcordoComAPendencia: "Tem certeza que deseja atualizar as informações desta data de acordo com a pendência? As alterações realizadas na FIRA nesta data serão perdidas",
        
        tituloInterrupcoes: "Interrupções",

        tabelaInterrupcoes: {
          Inicio: "Início",
          Fim: "Fim",
          Total: "Total",
        },

        tituloEquipamentos: "Equipamentos",

        tabelaEquipamentos: {
          Frota: "Frota",
        },      
      },

      tituloPapeleta: "Papeleta",

      tabelaPapeleta: {
        Data: "Data",
        Localidades: "Localidades",
        Situacao: "Situação",
        Horarios: "Horários",
        Totais: "Totais",
        Apresentacao: "Apresentação",
        Liberacao: "Liberação",
        ApresentacaoData: "Apresentação data",
        ApresentacaoHora: "Apresentação hora",
        InicioDaRefeicaoData: "Início da Refeição data",
        InicioDaRefeicaoHora: "Início da Refeição hora",
        TerminoDaRefeicaoData: "Término da Refeição data",
        TerminoDaRefeicaoHora: "Término da Refeição hora",
        InicioDaSegundaRefeicaoData: "Início da Segunda Refeição data",
        InicioDaSegundaRefeicaoHora: "Início da Segunda Refeição hora",
        TerminoDaSegundaRefeicaoData: "Término da Segunda Refeição data",
        TerminoDaSegundaRefeicaoHora: "Término da Segunda Refeição hora",
        LiberacaoData: "Liberação data",
        Liberacaohora: "Liberação hora",
        HorasDeJornada: "Horas de Jornada",
        VooNoturno: "Voo Noturno",
        VooTotal: "Voo Total",

        ///////editday
        DeletarFrota: "Tem certeza que deseja deletar essa frota?",
        DeletarInterrupcao: "Tem certeza que deseja deletar essa interrupção?",
        AtualizarInformacoesDestaData: "Tem certeza que deseja atualizar as informações desta data? As alterações realizadas na FIRA nesta data serão perdidas",
        
        placeholder: {
          SelecionarSituacao: "Selecionar situação",
        },

        tituloInterrupcoes: "Interrupções",

        formularioInterrupcoes: {
          InicioDaInterrupcao: "Início da interrupção",
          FimDaInterrupcao: "Fim da interrupção",

          botaoAdicionarInterrupcao: "Adicionar interrupção",
        },

        tabelaInterrupcoes: {
          Inicio: "Início",
          Fim: "Fim",
          Total: "Total",
          Acoes: "Ações",
        },

        tituloEquipamentos: "Equipamentos",

        formularioEquipamentos: {
          botaoAdicionarFrota: "Adicionar frota",

          placeholder: {
            SelecionarFrota: "Selecionar frota",
          }
        },

        tabelaEquipamentos: {
          Frota: "Frota",
          Acoes: "Ações",
        }
      },

      tituloAlertasDoRelatorio: "Alertas do relatório",

      tabelaAlertasDoRelatorio: {
        Mensagem: "Mensagem",
      },

      tituloAlertas: "Alertas",


      /////////aqui acaba o papersedit

      //////aprovals
      trocarStatus: "Tem certeza que deseja trocar o status da papeleta?",
      reabrir: "Tem certeza que deseja reabrir a papeleta?",

      botaoForcarAprovacao: "Forçar Aprovação",
      botaoAprovacaoTripulante: "Aprovação - Tripulante",
      botaoAprovacaoGestor: "Aprovação - Gestor",
      botaoReabrirPapeleta: "Reabrir papeleta",
      botaoPapeletaAprovada: "Papeleta aprovada",

      erros: "Os seguintes erros de preenchimento nos dias indicados impediram a papeleta de ser finalizada",

      tituloLogDeAprovacoes: "Log de aprovações",

      tabelaLogDeAprovacoes: {
        Usuario: "Usuário",
        Acao: "Ação",
        Data: "Data",
      },

     tituloFIRA: "FIRA",

     botaoReprovacaoGestor: "Reprovação - Gestor",

    },

    ListaDePapeletasFinalizadas: {
      deletar: "Tem certeza que gostaria de deletar essa papeleta?",

      titulo: "Lista de papeletas finalizadas",

      tabela: {
        semPapeletasPendentes: "Não há papeletas pendentes",
        ID: "ID",
        Nome: "Nome",
        Matricula: "Matrícula",
        Referencia: "Referência",
        Acoes: "Ações",
      }
    },

    ListaDePapeletasPendentesGestor: {
      deletar: "Tem certeza que gostaria de deletar essa papeleta?",

      titulo: "Lista de papeletas pendentes - Gestor",

      tabela: {
        semPapeletasPendentes: "Não há papeletas pendentes",
        ID: "ID",
        Nome: "Nome",
        Matricula: "Matrícula",
        Referencia: "Referência",
        Acoes: "Ações",
      }
    },

    ListaDePapeletasPendentesTripulantes: {
      deletar: "Tem certeza que gostaria de deletar essa papeleta?",

      titulo: "Lista de papeletas pendentes - Tripulantes",

      tabela: {
        semPapeletasPendentes: "Não há papeletas pendentes",
        ID: "ID",
        Nome: "Nome",
        Matricula: "Matrícula",
        Referencia: "Referência",
        Acoes: "Ações",
      }
    },

    ControleDePapeletas: {
      titulo: "Controle de papeletas",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Nome: "Nome",

        placeholder: {
          SelecionarTripulantes: "Selecionar tripulantes",
        }
      },

      tabela: {
        Tripulante: "Tripulante",
        SomaDeHorasDeJornada: "Soma de Horas de Jornada",
        SomaDeHorasDeVooNoturno: "Soma de Horas de Voo Noturno",
        SomaDeHorasDeVooTotal: "Soma de Horas de Voo Total",
      }
    },

    ConsultaDePapeletas: {
      titulo: "Consulta de papeletas",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
      },

      tabela: {
        MesAno: "Mês/Ano",
        Alertas: "Alertas",
        Acoes: "Ações",
      }
    },

    ConsultaDePapeletasGestores: {
      aguardeEnquantoOArquivoEGerado: "Aguarde enquanto o arquivo é gerado. Este processo pode levar alguns minutos.",

      titulo: "Consulta de papeletas - Gestores",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        Tripulante: "Tripulante",
        ExibirDesligados: "Exibir desligados",
        SomenteComAlertas: "Somente com alertas",
      },

      tabela: {
        Tripulante: "Tripulante",
        MesAno: "Mês/Ano",
        Alertas: "Alertas",
        Acoes: "Ações",
      }
    },
  },

  RelatoriosDeFadiga: {

    ListaDeRelatoriosDeFadigas: {
      botaoAdicionarRelatorioDeFadiga: "Adicionar relatório de fadiga",

      titulo: "Lista de relatórios de fadigas",

      tabela: {
        semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
        Data: "Data",
        Revisao: "Revisão",
        Tripulante: "Tripulante",
        Folga: "Folga",
        QuantidadeDePontosAtual: "Quantidade de pontos atual",
        QuantidadeDePontosReportados: "Quantidade de pontos reportados",
        Acoes: "Ações",
      }
    },

    AdicionarRelatorioDeFadiga: {
      noParametroAPontuacaoMaximaFoiUltrapassada(name){
        return `No parâmetro ${name} a pontuação máxima foi ultrapassada, confirma o envio do relatório?`
      },

      noParametroAPontuacaoMinimaNaoFoiAtingida(name){
        return `No parâmetro ${name} a pontuação mínima não foi atingida, confirma o envio do relatório?`
      },

      titulo: "Cadastrar relatório de fadiga",

      formulario: {
        Data: "Data",
        Bases: "Bases",
        
        botaoAdicionarRelatorioDeFadiga: "Adicionar relatório de fadiga",

        placeholder: {
          SelecionarBase: "Selecionar base",
          SelecionarOpcao: "Selecionar opção",
          Horas: "Horas",
          Quantidade: "Quantidade",
        }
      }

    },

    EditarRelatorioDeFadiga: {
      noParametroAPontuacaoMaximaFoiUltrapassada(name){
        return `No parâmetro ${name} a pontuação máxima foi ultrapassada, confirma o envio do relatório?`
      },

      noParametroAPontuacaoMinimaNaoFoiAtingida(name){
        return `No parâmetro ${name} a pontuação mínima não foi atingida, confirma o envio do relatório?`
      },

      titulo: "Edição de relatório de fadiga - Revisão",

      paragrafoStatusDaRevisao: "Status da revisão",
      paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
      paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados",

      tabRevisao: {
        tituloTab: "Revisão ",
        
        paragrafoStatusDaRevisao: "Status da revisão",
        paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
        paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados",
      },
      
      tituloCriarRevisao: "Criar revisão",
      
      formularioCriarRevisao: {

        botaoCriarRevisaoDeRelatorioDeFadiga: "Criar revisão de relatório de fadiga",

        placeholder: {
          SelecionarOpcao: "Selecionar opção",
          Horas: "Horas",
          Quantidade: "Quantidade",
        }
      }
    },

    EditarRelatorioDeFadigaAdministrador: {
      noParametroAPontuacaoMaximaFoiUltrapassada(name){
        return `No parâmetro ${name} a pontuação máxima foi ultrapassada, confirma o envio do relatório?`
      },

      noParametroAPontuacaoMinimaNaoFoiAtingida(name){
        return `No parâmetro ${name} a pontuação mínima não foi atingida, confirma o envio do relatório?`
      },

      titulo: "Edição de relatório de fadiga - Revisão",

      paragrafoStatusDaRevisao: "Status da revisão",
      paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
      paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados",

      tabRevisao: {
        tituloTab: "Revisão ",
        
        paragrafoStatusDaRevisao: "Status da revisão",
        paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
        paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados",
      },
      
      tituloCriarRevisao: "Criar revisão",
      
      formularioCriarRevisao: {
        botaoCriarRevisaoDeRelatorioDeFadiga: "Criar revisão de relatório de fadiga",

        placeholder: {
          SelecionarOpcao: "Selecionar opção",
          Horas: "Horas",
          Quantidade: "Quantidade",
        }
      }
    },

    AdicionarRelatorioDeFadigaAdministrador: {
      noParametroAPontuacaoMaximaFoiUltrapassada(name){
        return `No parâmetro ${name} a pontuação máxima foi ultrapassada, confirma o envio do relatório?`
      },

      noParametroAPontuacaoMinimaNaoFoiAtingida(name){
        return `No parâmetro ${name} a pontuação mínima não foi atingida, confirma o envio do relatório?`
      },

      titulo: "Cadastrar relatório de fadiga",

      formulario: {
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Tripulantes135: "Tripulantes - 135",
        Tripulantes121: "Tripulantes - 121",
        Mecanicos: "Mecânicos",
        Coordenadores: "Coordenadores",
        Data: "Data",
        Bases: "Bases",

        botaoAdicionarRelatorioDeFadiga: "Adicionar relatório de fadiga",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarTripulante: "Selecionar tripulante",
          SelecionarMecanico: "Selecionar mecânico",
          SelecionarCoordenador: "Selecionar coordenador",
          SelecionarBase: "Selecionar base",
          SelecionarOpcao: "Selecionar opção",
          Horas: "Horas",
          Quantidade: "Quantidade",
        }
      }

    },

    EditarParametroDeFadiga: {
      deletar: "Tem certeza que gostaria de deletar essa opção?",

      titulo: "Editar parâmetro de fadiga",

      formulario: {
        Nome: "Nome",
        Tipo: "Tipo",
        Operador: "Operador",
        PontosPorHora: "Pontos por hora",
        PontosPorQuantidade: "Pontos por quantidade",
        LimiteDePontos: "Limite de pontos",

        placeholder: {
          NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
          SelecionarCliente: "Selecionar cliente",
          QuantidadeDePontosPorHora: "Quantidade de pontos por hora",
          QuantidadeDePontosPorQuantidade: "Quantidade de pontos por quantidade",
        },
      }, 

      tituloAdicionarOpcoes: "Adicionar opções",

      formularioAdicionarOpcoes: {
          Nome: "Nome",
          Pontos: "Pontos",

          placeholder: {
            NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
            QuantidadeDePontos: "Quantidade de pontos",
          }
      },

      tituloOpcoes: "Opções",

      tabelaOpcoes: {
          Opcao: "Opção",
          Pontos: "Pontos",
          Acoes: "Ações",
      }

    },

    SimuladorDeRelatoriosDeFadiga: {
      titulo: "Simulador de relatórios de fadiga",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        QuantidadeDePontos: "Quantidade de pontos",

        botaoGerarSimulacaoDeRelatoriosDeFadiga: "Gerar simulação de relatórios de fadiga",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
        }
      },

      tabDatas: {
        botaoGerarRelatoriosDeFadiga: "Gerar relatórios de fadiga",
        botaoCopiarParaProximasDatas: "Copiar para próximas datas",

        formulario: {
          MarcarComoFolga: "Marcar como folga",
          Data: "Data",

          placeholder: {
            SelecionarOpcao: "Selecionar opção",
            Horas: "Horas",
            Quantidade: "Quantidade",
          }
        }
      },

      tabela: {
        Data: "Data",
        Diaria: "Diária",
        Acumulada: "Acumulada",
      }
    },

    RevisarHorariosDePonto: {
      titulo: "Revisar horários de ponto",

      tituloUtilizeEstaFerramentaParaCorrigirOsReportes: "Utilize esta ferramenta para corrigir os reportes de acordo com a API de ponto.",
      tituloAtencaoCasoOReportNaoExistaDeveraSerCriado: "Atenção: Caso o reporte não exista, ele deverá ser criado manualmente primeiro.",

      formulario: {
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Tripulantes135: "Tripulantes - 135",
        Tripulantes121: "Tripulantes - 121",
        Mecanicos: "Mecânicos",
        Coordenadores: "Coordenadores",
        Data: "Data",
        
        botaoRevisarHorarios: "Revisar horários",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarTripulante: "Selecionar tripulante",
          SelecionarMecanico: "Selecionar mecânico",
          SelecionarCoordenador: "Selecionar coordenador",
        }
      }
    },

    FiltroDeRelatorio: {
      deletar: "Tem certeza que gostaria de deletar esse parâmetro de fadiga?",

      titulo: "Pesquisa de relatórios",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Mecanicos: "Mecânicos",
        Coordenadores: "Coordenadores",
        Tripulantes: "Tripulantes",
        Cargos: "Cargos",
        Frotas: "Frotas",
        Bases: "Bases",
        ApenasIncidentesDeFadiga: "Apenas incidentes de fadiga",

        botaoProcurarRelatorios: "Procurar relatórios",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarMecanicos: "Selecionar Mecânicos",
          SelecionarCoordenadores: "Selecionar Coordenadores",
          SelecionarTripulantes: "Selecionar Tripulantes",
          SelecionarCargos: "Selecionar cargos",
          SelecionarFrotas: "Selecionar frotas",
          SelecionarBases: "Selecionar bases",
        }
      },

      tituloListaDeRelatoriosDeFadiga: "Lista de relatórios de fadiga",

      botaoMostrarEsconderTripulantes: "Mostrar/Esconder tripulantes",
      botaoFiltrarTripulantes: "Filtrar tripulantes",

      tabela: {
        Nome: "Nome",
        Pontos: "Pontos",
      }

    },

    RelatorioDeEventosIncidentesDeFadiga: {
      titulo: "Relatório de Eventos/Incidentes de Fadiga",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Mecanicos: "Mecânicos",
        Coordenadores: "Coordenadores",
        Tripulantes: "Tripulantes",
        TipoDeEventoIncidente: "Tipo de Evento/Incidente",
        ApenasIncidentesDeFadigaChecados: "Apenas incidentes de fadiga checados",

        botaoProcurarRelatorios: "Procurar relatórios",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarMecanicos: "Selecionar Mecânicos",
          SelecionarCoordenadores: "Selecionar Coordenadores",
          SelecionarTripulantes: "Selecionar Tripulantes",
          SelecionarIncidente: "Selecionar incidente",
        }
      },

      tituloListaDeEventosIncidentesDeFadiga: "Lista de eventos/incidentes de fadiga",

      tabela: {
        semEventosIncidentesDeFadiga: "Não ocorreram eventos/incidentes de fadiga no período",
        ID: "ID",
        TipoDeEvento: "Tipo de Evento",
        Data: "Data",
        Revisao: "Revisão",
        Tripulante: "Tripulante",
        PontuacaoReportada: "Pontuação reportada",
        PontuacaoTotal: "Pontuação total",
        Checado: "Checado",
        DataDaChecagem: "Data da Checagem",
        AcaoRealizada: "Ação Realizada",
        Acoes: "Ações",
      },

      tituloEditarPlanoDeAcao: "Editar plano de ação",

      formularioEditarPlanoDeAcao: {
        PlanoDeAcao: "Plano de Ação",

        botaoEditarPlanoDeAcao: "Editar plano de ação"
      },

      marcarEsteIncidenteComoChecado: "Tem certeza que deseja marcar este incidente como checado?",
    },

    PesquisaDeRelatoriosNaoPreenchidos: {
      titulo: "Pesquisa de relatórios não preenchidos",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Bases: "Bases",
        IncluirFolgaCadastradaAutomaticamente: "Incluir folga cadastrada automaticamente",

        botaoProcurarRelatorios: "Procurar relatórios",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarBase: "Selecionar base",
        }
      },

      tituloListaDeRelatOriosDeFadigasFaltantes: "Lista de relatórios de fadigas faltantes",

      tabela: {
        semReportesFaltantes: "Não há reportes faltantes nesse período",
        Nome:"Nome",
        Data: "Data",
        Situacao: "Situação",
      }
    },

    PesquisaDeRelatorios: {
      titulo: "Pesquisa de relatórios",

      formulario: {
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Mecanicos: "Mecânicos",
        Coordenadores: "Coordenadores",
        Tripulantes: "Tripulantes",
        Cargos: "Cargos",
        Bases: "Bases",

        botaoProcurarRelatarios: "Procurar relatórios",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarMecanicos: "Selecionar Mecânicos",
          SelecionarCoordenadores: "Selecionar Coordenadores",
          SelecionarTripulantes: "Selecionar Tripulantes",
          SelecionarCargos: "Selecionar cargos",
          SelecionarBases: "Selecionar bases",
        }
      },

      tituloTotalDoPeriodo: "Total do Período",

      tabelaTotalDoPeriodo: {
        semParametrosDeFadiga: "Não há parâmetros de fadiga cadastrados",
        NaoFadigados: "Não fadigados",
        PontosAzul: "Pontos Azul",
        PontosAmarelo: "Pontos Amarelo",
        PontosVermelho: "Pontos Vermelho",
      },

      tituloTotalDiario: "Total Diário",

      tabelaTotalDiario: {
        semParametrosDeFadiga: "Não há parâmetros de fadiga cadastrados",
        Data: "Data",
        NaoFadigados: "Não fadigados",
        PontosAzul: "Pontos Azul",
        PontosAmarelo: "Pontos Amarelo",
        PontosVermelho: "Pontos Vermelho",
      },

      tituloListaDeRelatoriosDeFadigas: "Lista de relatórios de fadigas",

      tabelaListaDeRelatoriosDeFadigas: {
        semParametrosDeFadiga: "Não há parâmetros de fadiga cadastrados",
        Data: "Data",
        Revisao: "Revisão",
        Tripulante: "Tripulante",
        Folga: "Folga",
        QuantidadeDePontosAtual: "Quantidade de pontos atual",
        QuantidadeDePontosReportados: "Quantidade de pontos reportados",
        DiaDePreenchimento: "Dia de preenchimento",
        Acoes: "Ações",
      },

      tituloDadosDoRelatorioDeFadiga: "Dados do relatório de fadiga",

      paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
      paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados",

      tabelaDadosDoRelatorioDeFadiga: {
        Parametro: "Parâmetro",
        Dados: "Dados",
        Pontos: "Pontos",
      }
    },
  },

  HorasDeVoo: {

    VisualizarHorasDeVoo: {  
      opcoesTipo: {
        Sintetica: "Sintética (Ignora filtro de data)",
        Analitica: "Analítica",
      },

      eNecessarioPreencherDataDeInicioEFimParaPesquisasAnaliticas: "É necessário preencher data de início e fim para pesquisas analíticas",
      
      titulo: "Visualizar horas de voo",

      formulario: {
        DataInicial: "Data Inicial",
        DataFinal: "Data Final",
        FB: "FB",
        Listagem: "Listagem",
        Modelo: "Modelo",

        placeholder: {
          SelecionarTipo: "Selecionar tipo",
          SelecionarModelosDeAeronave: "Selecionar modelos de aeronave",
        }
      },

      tabela: {
        semAeronaves: "Não há aeronaves cadastrados",
        ID: "ID",
        Data: "Data",
        Matricula: "Mat.",
        Apelido: "Apelido",
        Modelo: "Modelo",
        FB: "FB",
        Simulador: "Simulador",
        Total: "Total",
        IFR: "IFR.",
        Noturno: "Noturno",
        APP: "APP",
        Diu: "Diu",
        Not: "Not",
        CgExt: "Cg. Ext.",
      },

      tituloTotais: "Totais",

      tabelaTotais: {
        semAeronaves: "Não há aeronaves cadastrados",
        ID: "ID",
        Matricula: "Mat.",
        Apelido: "Apelido",
        Modelo: "Modelo",
        Total: "Total",
        IFR: "IFR.",
        Noturno: "Noturno",
        APP: "APP",
        Diu: "Diu",
        Not: "Not",
      }
    }
  },

  Solicitacoes: {
    ListaDeSolicitacoes: {
      titulo: "Lista de Solicitações",

      tabela: {
        semSolicitacoes: "Não há solicitações cadastradas",
        ID: "ID",
        DataDeCriacao: "Data de Criação",
        Inicio: "Início",
        Fim: "Fim",
        Justificativa: "Justificativa",
        Status: "Status",
        ChefeDeFrota: "Chefe de Frota",
        ChefeDeFrotaDataResposta: "Chefe de Frota - Data Resposta",
        ChefeDeFrotaAprovacao: "Chefe de Frota - Aprovação",
        ChefeDeFrotaJustificativa: "Chefe de Frota - Justificativa",
        Administrativo: "Administrativo",
        AdministrativoDataResposta: "Administrativo - Data Resposta",
        AdministrativoAprovacao: "Administrativo - Aprovação",
        AdministrativoResposta: "Administrativo - Resposta",
      }
    },

    AdicionarSolicitacaoDeAlteracaoDeEscala: {
      criar: "Tem certeza de que deseja criar esta solicitação?",

      titulo: "Cadastrar Solicitação de Alteração de Escala",

      formulario: {
        Inicio: "Início",
        Fim: "Fim",
        Razao: "Razão",
      },
    },
    
    ListaDeSolicitacoesSigmec: {
      confirmarMudanca: "Tem certeza de que deseja mudar o status desta solicitação?",
      
      titulo: "Lista de Solicitações",

      tabela: {
        semSolicitacoes: "Não há solicitações cadastradas",
        ID: "ID",
        Escala: "Escala",
        Colaborador: "Colaborador",
        TipoDeSolicitacao: "Tipo de solicitação",
        Justificativa: "Justificativa",
        Status: "Status",
        Acoes: "Ações",
      },
      modal: {
        titulo: "Visualização de requisição",
        formulario: {
          EscalaMesAtual: "Escalas do mês atual",
          Atestado: "Atestado",
          Colaborador: "Colaborador",
          TipoDeAlteracao: "Tipo de alteração",
          Solicitante: "Solicitante",
          DataDeInicio: "Data de início",
          DataDeTermino: "Data de término",
          Definitiva: "A alteração é definitiva?",
          TempoIndeterminado: "Tempo Indeterminado",
          Descrição: "Descrição",
          Justificativa: "Justificativa",
          NumeroChamado: "N° do chamado",
          NumeroMp: "N° da MP aprovada",
          Atestado: "Atestado",
          Descricao: "Descrição",
          BaseAtual: "Base Atual",
          NovaBase: "Nova Base",
          FuncaoAtual: "Função Atual",
          NovaFuncao: "Nova Função",
          QuinzenaAtual: "Quinzena Atual",
          NovaQuinzena: "Nova Quinzena",
          PeriodoAtual: "Período Atual",
          NovaPeriodo: "Nova Período",
          GrupoAtual: "Grupo Atual",
          NovoGrupo: "Novo Grupo",
        },
        modal_additional: {
          Exigencia: "Exigência",
          Resposta: "Resposta",
          botaoEnviarInformacaos: "Enviar Informações",
          botaoAprovar: "Aprovar",
          botaoReprovar: "Reprovar",
        }
      }
    },
    
    AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec: {
      titulo: "Cadastrar Solicitação de Alteração de Escala SIGMEC",
      erros: "Foram encontradosos seguintes erros ao tentar solicitar alterações",
      tabela: {
        EscalaMesAtual: "Escalas do mês atual",
        Colaborador: "Colaborador",
        TipoDeAlteracao: "Tipo de alteração",
        DataDeInicio: "Data de início",
        DataDeTermino: "Data de término",
        Duracao: "A alteração é definitiva? / Tempo Indeterminado",
        Justificativa: "Justificativa",
        Atual: "Atual",
        Novo: "Novo",
        NumeroChamado: "N° do chamado",
        NumeroMp: "N° da MP aprovada",
        Atestado: "Atestado",
        Descricao: "Descrição",
        Acoes: "Ações",
      },
      formulario: {
        placeholder: {
          SelecioneEscala: "Selecione uma escala",
          selecioneColaborador: "Selecione um colaborador",
          SelecioneTipoDeAlteracao: "Selecione um tipo de alteração",
          SelecineGrupo: "Selecione um grupo",
          SelecineQuinzena: "Selecione uma quinzena",
          SelecineBase: "Selecione uma base",
          SelecinePeriodo: "Selecione um período",
          SelecineFuncao: "Selecione uma função",
          SelecineFuncao: "Selecione uma função",
          NumeroChamado: "N° do chamado",
          NumeroMp: "N° da MP aprovada",
          Atestado: "Atestado",
        },
        botaoSalvarSolicitacoes: "Adicionar solicitações",
        botaoAdicionarSolicitacao: "Adicionar solicitação",
    },
      
    },
  },

  Tarefas: {

    ListaDeTarefas: {
      titulo: "Lista de tarefas",
      
      botaoAdicionarTarefa: "Adicionar tarefa",

      tabela: {
        semTarefas: "Não há tarefas cadastradas",
        ID: "ID",
        Nome: "Nome",
        Acoes: "Ações",
      }
    },

    AdicionarTarefa: {
      titulo: "Cadastrar tarefas de restrição",

      formulario: {
        Tarefa: "Tarefa",

        botaoCadastrarTarefa: "Cadastrar tarefa",

        placeholder: {
          TarefaDeRestricao: "Tarefa de restrição",
        }
      }
    },

    EditarTarefa: {
      titulo: "Editar tarefa de restrição",

      formulario: {
        Tarefa: "Tarefa",

        placeholder: {
          TarefaDeRestricao: "Tarefa de restrição",
        }
      }
    }
  },

  Sessoes: {
    AdicionarSessao: {
      deletar: "Tem certeza que gostaria de deletar essa sessão?",
      finalizar: "Tem certeza que gostaria de finalizar essa sessão?",
      reabrir: "Tem certeza que gostaria de reabrir essa sessão?",

      osDadosForamAtualizadosComSucesso: "Os dados foram atualizados com sucesso",

      botaoAberto: "Aberto",
      botaoFinalizado: "Finalizado",
      botaoConfirmado: "Confirmado",

      titulo: "Adicionar sessão",

      formulario: {
        Treinamento: "Treinamento",
        Data: "Data",
        Inicio: "Início",
        Fim: "Fim",
        Examinador: "Examinador",
        Instrutor: "Instrutor",
        PilotFlying: "Pilot Flying",
        PilotMonitoring: "Pilot Monitoring",

        botaoAdicionarSessao: "Adicionar sessão",

        placeholder: {
          SelecionarCertificado: "Selecionar certificado",
          Data: "Data",
          HorarioDeInicio: "Horário de início",
          HorarioDeFim: "Horário de fim",
        }
      },

      tituloListaDeSessoes: "Lista de sessões",

      tabela: {
        semTarefas: "Não há tarefas cadastradas",
        ID: "ID",
        Treinamento: "Treinamento",
        Certificado: "Certificado",
        Inicio: "Início",
        Fim: "Fim",
        HorasTotais: "Horas Totais",
        Arquivo: "Arquivo",
        Status: "Status",
        Acoes: "Ações",
      },

      importarArquivo: "Tem certeza que gostaria de importar este arquivo? Ao importar, o arquivo anterior, se houver, será substituido permanentemente.",

      formularioAdicionarArquivo: {

        placeholder: {
          Arquivo: "Arquivo",
        }
      },

      opcoesTipo: {
        Examinador: "Examinador",
        Instrutor: "Instrutor",
        PilotFlying: "Pilot Flying",
        PilotMonitoring: "Pilot Monitoring",
      },

      deletarTripulante: "Tem certeza que deseja deletar esse tripulante?",

      tituloAdicionarTripulante: "Adicionar tripulante",

      tabelaTripulantes: {
        Tripulante: "Tripulante",
        Matricula: "Matrícula",
        Tipo: "Tipo",
        Acoes: "Ações",
      }

    }
  },

  LinksUteis: {
    LinksUteis: {
      deletar: "Tem certeza que gostaria de deletar esse link?",
      
      titulo: "Links Úteis",

      tabela: {
        semIncompatibilidades: "Não há incompatibilidades cadastradas",
        ID: "ID",
        Nome: "Nome",
        Link: "Link",
      }
    }
  },

  Usuarios: {
    AlteracaoDeSenha: {
      titulo: "Alteração de senha",

      formulario: {
        SenhaAtual: "Senha atual",
        NovaSenha: "Nova senha",
        RepitaANovaSenha: "Repita a nova senha",

        placeholder: {
          SenhaAtual: "Senha atual",
          NovaSenha: "Nova senha",
          RepitaANovaSenha: "Repita a nova senha",  
        }
      }
    },

    SistemaSuspensoParaManutencao: {
      titulo: "Sistema suspenso para manutenção",

      tituloAtualizacao: "Atualização",

      paragrafoPrevisaoDeVolta: "Previsão de volta",
    },

    RecuperarSenha: {
      formulario: {

        botaoRecuperarSenha: "Recuperar senha",

        placeholder: {
          SeuEmail: "Seu e-mail",
        }
      },

      paragrafoVoltarParaLogin: "Voltar para login",
    },

    Login: {
      usuarioNaoCadastrado: "Usuário não cadastrato. Solicite a TI a criação do usuário.",
      usuarioInativo: "Usuário inativo neste sistema. Solicite a TI a liberação do usuário.",
      usuarioSemPermissoes: "Usuário sem permissões para este sistema. Solicite a TI as permissões de acesso para este usuário.",
      usuarioOuSenhaInvalidos: "Usuário ou senha inválidos.",

      paragrafoModuloAdministrativo: "MÓDULO ADMINISTRATIVO",

      formulario: {
        paragrafoAtencao: "ATENÇÃO: VOCÊ ACESSARÁ O AMBIENTE DE HOMOLOGAÇÃO",

        botaoAcessarOSistema: "Acessar o sistema",

        placeholder: {
          SeuEmail: "Seu E-mail",
          SuaSenha: "Sua senha",
        }
      },

      paragrafoOLoginDeveSerFeitoComUsuarioESenhaOmniRubi: "O LOGIN DEVE SER FEITO COM O USUÁRIO E SENHA OMNI/RUBI",

      paragrafoEsqueciMinhaSenha: "Esqueci minha senha",

      paragrafoEntreEmContato: "Entre em contato com o setor de TI.",

      paragrafoPortalDeColaboradores: "PORTAL DE COLABORADORES",
    },

    Questionario: {

      titulo: "Questionário",

      formulario: {
        VoceConcordaQueSeSentiuFadigadoNosUltimosDias: "Você concorda que se sentiu fadigado nos últimos dias",
        SelecioneOsFatoresQueContribuiramParaAFadiga: "Selecione os fatores que contribuíram para a fadiga",

        opcoesFatoresQueContribuiramParaAFadiga: {
          NaoMeSentiFadigado: "Não me senti fadigado",
          DescansoInsuficienteEntreJornadas: "Descanso insuficiente entre jornadas",
          JornadaInterrompida: "Jornada interrompida",
          TransicaoDaJornadaDiurnoParaNoturno: "Transição da jornada (diurno para noturno)",
          TransicaoDaJornadaNoturnoParaDiurno: "Transição da jornada (noturno para diurno)",
          HorarioDeInicioDaJornadaDiurno: "Horário de início da jornada (diurno)",
          HorarioDeInicioDaJornadaNoturno: "Horário de início da jornada (noturno)",
          TrabalhoNoturno: "Trabalho noturno",
          DuracaoDaJornada: "Duração da jornada",
          HoraExtra: "Hora extra",
          Transporte: "Transporte",
          Saude: "Saúde",
          FadigaAcumulada: "Fadiga acumulada",
          ProblemasPessoais: "Problemas Pessoais",
        },

        HistoricoDoSonoDosUltimos3Dias: "Histórico do Sono dos últimos 3 dias",
        QueHorasDormiuNoUltimoDia: "Que horas dormiu no último dia",
        QueHorasAcordouNoUltimoDia: "Que horas acordou no último dia",
        QualidadeDoSonoNoUltimoDia: "Qualidade do sono no último dia",

        opcoesSono: {
          Otimo: "Ótimo",
          Bom: "Bom",
          Normal: "Normal",
          Ruim: "Ruim",
          Pessimo: "Péssimo",
        },

        QueHorasDormiuNoPenultimoDia: "Que horas dormiu no penúltimo dia",
        QueHorasAcordouNoPenultimoDia: "Que horas acordou no penúltimo dia",
        QualidadeDoSonoNoPenultimoDia: "Qualidade do sono no penúltimo dia",

        QueHorasDormiuHa3Dias: "Que horas dormiu há 3 dias",
        QueHorasAcordouHa3Dias: "Que horas acordou há 3 dias",
        QualidadeDoSonoHa3Dias: "Qualidade do sono há 3 dias",
        
        SinaisFisiologicosECognitivos: "Sinais fisiológicos e cognitivos",

        opcoesSinaisFisiologicos: {
          NaoMeSentiFadigado: "Não me senti fadigado",
          NenhumSinalFisicoPercebido: "Nenhum sinal físico percebido",
          EsfregarOsOlhosComFrequencia: "Esfregar os olhos com frequência",
          PiscadasFrequentes: "Piscadas frequentes",
          Bocejo: "Bocejo",
          OlharFixo: "Olhar fixo",
          DificuldadeEmManterOsOlhosAbertos: "Dificuldade em manter os olhos abertos",
          PiscadasLongas: "Piscadas longas",
          CabeçaBalancandoOuCaindo: "Cabeça balançando ou caindo",
          Inquietacao: "Inquietação",
        },

        Contramedidas: "Contramedidas",

        opcoesContramedidas: {
          NaoMeSentiFadigado: "Não me senti fadigado",
          AlertouAoColegaSobreORiscoDeFadiga: "Alertou ao colega sobre o risco de fadiga",
          AumentouAComunicacao: "Aumentou a comunicação",
          ComidaOuBebida: "Comida ou bebida",
          Soneca: "Soneca",
          CoordenouACargaDeTrabalho: "Coordenou a carga de trabalho",
          Cafeina: "Cafeína",
        },

        DetalhamentoECausasProvaveis: "Detalhamento e causas prováveis",
        VoceAcreditaQueOSistemaDeGerenciamentoDeFadigaEEficiente: "Você acredita que o sistema de gerenciamento de fadiga é eficiente",
        Sugestoes: "Sugestões",

        botaoResponder: "Responder",

        placeholder: {
          SelecionarUmaOpcao: "Selecionar uma opção",
          HorarioDeApresentacao: "Horário de Apresentação",
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          CasoNaoTenhaSeSentidoFadigadoPreenchaComNA: "Caso não tenha se sentido fadigado, preencha com N/A",
        }
      }

    },

    TesteDeSonolencia: {
      titulo: "Teste de sonolência",

      formulario: {
        HorarioDeInicioDaJornada: "Horário de Início da Jornada",
        ComoVoceEstaSeSentindoAgora: "Como você está se sentindo agora",

        opcoesComoVoceEstaSeSentindoAgora: {
          ExtremamenteAlerta: "Extremely alert (Extremamente alerta)",
          MuitoAlerta: "Very alert (Muito alerta)",
          Alerta: "Alert (Alerta)",
          RazoavelmenteAlerta: "Fairly alert (Razoavelmente alerta)",
          NemAlertaNemSonolento: "Neither alert nor sleepy (Nem alerta nem sonolento)",
          AlgunsSinaisDeSonolencia: "Some signs of sleepiness (Alguns sinais de sonolência)",
          SonolentoMasConsigoMeManterAcordado: "Sleepy, but no effort to keep alert (Sonolento, mas consigo me manter acordado)",
          SonolentoPrecisoMeConcentrarParaMeManterAcordado: "Sleepy, some effort to keep alert (Sonolento, preciso me concentrar para me manter acordado)",
          MuitosonolentoMuitoEsforcoParaMeManterAcordadoLutandoComOSono: "Very sleepy, great effort to keep alert, fighting sleep (Muito sonolento, muito esforço para me manter acordado, lutando com o sono)",
        },

        botaoResponder: "Responder",

        placeholder: {
          HorarioDeApresentacao: "Horário de Apresentação",
        }
      }
    }

  }

});

export default getLocale;



// WEBPACK FOOTER //
// ./src/i18n/pt-BR.jsx